<ng-container *ngIf="showView">
  <div class="content" *ngIf="employee$ | async as employee; else loading">
    <!-- Breadcrumb -->
    <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
      <div class="my-auto mb-2">
        <h6 class="fw-medium d-inline-flex align-items-center mb-3 mb-sm-0">
          <a [routerLink]="['/hrm/employee']">
            <!-- <a href="javascript:void(0);" (click)="goBack()"> -->
            <i class="ti ti-arrow-left me-2"></i> Employee Details
          </a>
        </h6>
      </div>
      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
        <!-- <ng-container *ngIf="!isViewedEmployeeBusinessOwner && employeeId !== user?.id"> -->
        <div class="mb-2 me-2" *appHasPermission="[{ employees: ['edit'] }]">
          <a
            href="javascript:void(0);"
            class="btn btn-primary d-inline-flex align-items-center me-2"
            (click)="openBusinessModal(assignManagerModal, { modalType: 'assignManager' })"
          >
            <i class="ti ti-circle-plus me-2"></i>Change Manager
          </a>
        </div>
        <!-- </ng-container> -->
        <ng-container *ngIf="employee.id !== user?.id && employee.disabled === false">
          <div class="mb-2 me-2" *appHasPermission="[{ employees: ['edit'] }]">
            <a
              href="javascript:void(0)"
              class="btn btn-primary d-flex align-items-center"
              (click)="
                openModal(
                  employee.portalAccess === true ? false : true,
                  employee.id.toString(),
                  'portal'
                )
              "
            >
              <i
                class="ti me-2"
                [ngClass]="{
                  'ti-lock-open': employee.portalAccess,
                  'ti-lock': !employee.portalAccess
                }"
              ></i>
              {{ employee.portalAccess ? 'Revoke Access' : 'Give Access' }}
            </a>
          </div>
        </ng-container>

        <div class="mb-2 me-2" *ngIf="employee.id === user?.id">
          <a
            href="#"
            data-bs-toggle="modal"
            data-bs-target="#changePasswordModal"
            class="btn btn-primary d-flex align-items-center"
          >
            Change Password
          </a>
        </div>

        <div class="mb-2 me-2" *ngIf="isBusinessOwner">
          <a
            href="#"
            data-bs-toggle="modal"
            data-bs-target="#resetPasswordModal"
            class="btn btn-primary d-flex align-items-center"
          >
            Reset Password
          </a>
        </div>

        <!-- <ng-container *ngIf="!employee.offboard"> -->
        <ng-container
          *appHasPermission="[
            { offBoarding: ['view'] },
            { offBoarding: ['edit'] },
            { offBoarding: ['create'] }
          ]"
        >
          <div class="mb-2 me-2" *ngIf="!isViewedEmployeeBusinessOwner">
            <a
              href="javascript:void(0)"
              (click)="openBusinessModal(offBoardModal, { modalType: 'offBoard' })"
              class="btn btn-primary d-flex align-items-center"
            >
              Off Boarding
            </a>
          </div>
        </ng-container>
        <!-- </ng-container> -->

        <div class="head-icons ms-2 d-none">
          <a
            href="javascript:void(0);"
            class=""
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            data-bs-original-title="Collapse"
            id="collapse-header"
          >
            <i class="ti ti-chevrons-up"></i>
          </a>
        </div>
      </div>
    </div>
    <!-- /Breadcrumb -->

    <div class="row">
      <div class="col-xl-4 theiaStickySidebar">
        <!-- PROFILE CARD -->
        <!-- <div class="card card-bg-1 mb-3">
          <div class="card-body" style="margin: -20px">
            <span
              class="avatar avatar-xxl border bg-white rounded-circle mx-auto d-flex mb-2 align-items-center justify-content-center"
            >
              <ng-container *ngIf="employee.picture; else initials">
                <img
                  [src]="apiEndpoint + '/uploads/' + employee.picture"
                  class="rounded-circle border border-2 w-100 h-100"
                  style="object-fit: cover; object-position: center"
                  alt="img"
                  (error)="employee.picture = null"
                />
              </ng-container>

              <ng-template #initials>
                <span
                  class="avatar avatar-xxl rounded-circle d-flex align-items-center justify-content-center bg-primary text-white fw-bold border border-2"
                >
                  {{ getInitials(employee.firstName, employee.lastName) }}
                </span>
              </ng-template>
            </span>
            <div class="text-center px-3 pb-3">
              <div class="mb-3">
                <h5 class="d-flex align-items-center justify-content-center mb-1">
                  {{ employee.firstName }} {{ employee.lastName }}
                  <i
                    *ngIf="!employee.disabled"
                    class="ti ti-discount-check-filled text-success ms-1"
                  ></i>
                  <i *ngIf="employee.disabled" class="ti ti-ban text-danger ms-1"></i>
                </h5>
                <span class="badge badge-soft-dark fw-medium me-2" *ngIf="employee.designation">
                  
                  {{
                    employee.designation ? (employee.designation.designationName | capitalize) : ''
                  }}
                </span>
                <span class="badge badge-soft-secondary fw-medium" *ngIf="employee.designation"
                  >{{ totalExperienceYears }}+ of Experience
                </span>
              </div>
            </div>
          </div>
        </div> -->

        <div class="card employee-profile-card mb-3">
          <div class="employee-banner"></div>
          <div class="card-body pt-0 text-center">
            <span class="avatar avatar-xxl employee-avatar mx-auto d-flex mb-3">
              <ng-container *ngIf="employee.picture; else initials">
                <img
                  [src]="apiEndpoint + '/uploads/' + employee.picture"
                  class="employee-avatar-img"
                  alt="img"
                  loading="lazy"
                  (error)="employee.picture = null"
                />
              </ng-container>

              <ng-template #initials>
                <span class="employee-avatar-fallback">
                  {{ getInitials(employee.firstName, employee.lastName) }}
                </span>
              </ng-template>
            </span>

            <h5 class="fw-bold mb-1 d-flex align-items-center justify-content-center">
              {{ employee.firstName }} {{ employee.lastName }}
              <i
                *ngIf="!employee.disabled"
                class="ti ti-discount-check-filled text-success ms-1"
              ></i>
              <i *ngIf="employee.disabled" class="ti ti-ban text-danger ms-1"></i>
            </h5>

            <div class="d-flex align-items-center justify-content-center flex-wrap gap-2 mb-1">
              <span class="badge employee-badge-designation" *ngIf="employee.designation">
                {{
                  employee.designation ? (employee.designation.designationName | capitalize) : ''
                }}
              </span>
              <span class="badge employee-badge-experience" *ngIf="employee.designation">
                {{ totalExperienceYears }}+ of Experience
              </span>
            </div>
            <div>
              <div class="d-flex align-items-center justify-content-between mb-2">
                <span class="d-inline-flex align-items-center">
                  <i class="ti ti-id me-2"></i>
                  Employment Type
                </span>

                <!-- <p class="text-primary"> -->
                <span class="d-flex align-items-center">
                  <!-- <a
                      class="text-primary me-2"
                      href="javascript:void(0)"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasRightRoles"
                      aria-controls="offcanvasRightRoles"
                      (click)="openOffcanvasRoles(employee.userRole)"
                    >
                      {{ employee.employmentType }}
                    </a> -->
                  {{ employee.employmentType }}
                  <!-- <ng-container *ngIf="employee.id !== user?.id">
                    <a
                      *appHasPermission="[{ userRole: ['edit'] }, { userRole: ['add'] }]"
                      href="javascript:void(0);"
                      (click)="openBusinessModal(assignRoleModal, { modalType: 'assignRole' })"
                      class="text-secondary"
                    >
                      (Change)
                    </a>
                  </ng-container> -->
                </span>
                <!-- </p> -->
              </div>
              <!-- <div class="d-flex align-items-center justify-content-between mb-2">
                <span class="d-inline-flex align-items-center">
                  <i class="ti ti-id me-2"></i>
                  Employee ID
                </span>
                <p class="text-dark">{{ employee.empId }}</p>
              </div>
              <div
                class="d-flex align-items-center justify-content-between mb-2"
                *ngIf="employee.designation"
              >
                <span class="d-inline-flex align-items-center">
                  <i class="ti ti-star me-2"></i>
                  Department
                </span>
                <p class="text-dark">
                  {{ employee.designation ? employee.designation.department?.departmentName : '' }}
                </p>
              </div>
              <div class="d-flex align-items-center justify-content-between mb-2">
                <span class="d-inline-flex align-items-center">
                  <i class="ti ti-calendar-check me-2"></i>
                  Date Of Join
                </span>
                <p class="text-dark">{{ employee.joiningDate | date }}</p>
              </div>
              <div class="d-flex align-items-center justify-content-between mb-2">
                <span class="d-inline-flex align-items-center">
                  <i class="ti ti-calendar-check me-2"></i>
                  Report Office
                </span>
                <div class="d-flex align-items-center"> -->
              <!-- <span class="avatar avatar-sm avatar-rounded me-2">
                      <img [src]="apiEndpoint + employee.office.user?.picture" alt="Img">
                    </span> -->
              <!-- <p class="text-gray-9 mb-0">{{ employee.office?.officeName }}</p>
                </div>
              </div> -->
              <div class="d-flex align-items-center justify-content-between mb-2">
                <span class="d-inline-flex align-items-center">
                  <i class="ti ti-calendar-check me-2"></i>
                  Manager
                </span>
                <div class="d-flex align-items-center">
                  <p class="text-gray-9 mb-0">{{ manager }}</p>
                </div>
              </div>
              <div class="d-flex align-items-center justify-content-between mb-2">
                <span class="d-inline-flex align-items-center">
                  <i class="ti ti-calendar-check me-2"></i>
                  Request Manager
                </span>
                <div class="d-flex align-items-center">
                  <p class="text-gray-9 mb-0">{{ requestManager }}</p>
                </div>
              </div>
              <div class="d-flex align-items-center justify-content-between">
                <span class="d-inline-flex align-items-center">
                  <i class="ti ti-calendar-check me-2"></i>
                  HR Manager
                </span>
                <div class="d-flex align-items-center">
                  <p class="text-gray-9 mb-0">{{ hrManager }}</p>
                </div>
              </div>
              <div class="row gx-2 mt-3 d-none">
                <div class="col-6">
                  <div>
                    <a
                      href="#"
                      class="btn btn-dark w-100"
                      data-bs-toggle="modal"
                      data-bs-target="#edit_employee"
                      ><i class="ti ti-edit me-1"></i>Edit Info</a
                    >
                  </div>
                </div>
                <div class="col-6">
                  <div>
                    <a
                      href="https://smarthr.dreamstechnologies.com/html/template/chat.html"
                      class="btn btn-primary w-100"
                      ><i class="ti ti-message-heart me-1"></i>Message</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- BASIC INFORMATION CARD -->
        <div class="card mb-3">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <h6 class="mb-0">Basic Information</h6>

              <a
                href="javascript:void(0);"
                class="btn btn-icon btn-sm"
                *appHasPermission="[{ employees: ['edit'] }]"
                (click)="openBusinessModal(addBusinessModal, employee, 'addBusinessModal')"
              >
                <i class="ti ti-edit"></i>
              </a>
            </div>

            <!-- Mobile -->

            <div class="d-flex align-items-center justify-content-between mb-3">
              <span class="d-inline-flex align-items-center">
                <i class="ti ti-phone me-2"></i>
                Mobile
              </span>

              <p class="text-dark mb-0">
                {{ employee.mobile }}
              </p>
            </div>

            <!-- Email -->

            <div class="d-flex align-items-center justify-content-between mb-3">
              <span class="d-inline-flex align-items-center">
                <i class="ti ti-mail-check me-2"></i>
                Work Email
              </span>

              <p class="text-dark mb-0">
                <a
                  href="javascript:void(0);"
                  class="text-info d-inline-flex align-items-center"
                  (click)="copyContent(employee.email)"
                  ><span
                    class="__cf_email__"
                    data-cfemail="cfbfaabdbdaea3bbfefd8faab7aea2bfa3aae1aca0a2"
                    >{{ employee.email }}</span
                  ><i class="ti ti-copy text-dark ms-2"></i
                ></a>
              </p>
            </div>

            <!-- Gender -->

            <div class="d-flex align-items-center justify-content-between mb-3">
              <span>
                <i class="ti ti-gender-male me-2"></i>
                Gender
              </span>

              <p class="text-dark mb-0">
                {{ employee.gender }}
              </p>
            </div>

            <div class="d-flex align-items-center justify-content-between mb-3">
              <span>
                <i class="ti ti-calendar me-2"></i>
                Date of Birth
              </span>

              <p class="text-dark mb-0">
                {{ employee.birthdate | date: 'MMM d, y' }}
              </p>
            </div>

            <div class="d-flex align-items-center justify-content-between mb-3">
              <span>
                <i class="ti ti-id me-2"></i>
                Employee ID
              </span>

              <p class="text-dark mb-0">
                {{ employee.empId }}
              </p>
            </div>

            <div class="d-flex align-items-center justify-content-between mb-3">
              <span>
                <i class="ti ti-star me-2"></i>
                Department
              </span>

              <p class="text-dark mb-0">
                {{ employee.designation ? employee.designation.department?.departmentName : '' }}
              </p>
            </div>

            <div class="d-flex align-items-center justify-content-between mb-3">
              <span>
                <i class="ti ti-calendar-check me-2"></i>
                Date Of Join
              </span>

              <p class="text-dark mb-0">
                {{ employee.joiningDate | date: 'MMM d, y' }}
              </p>
            </div>

            <div class="d-flex align-items-center justify-content-between mb-3">
              <span>
                <i class="ti ti-building me-2"></i>
                Report Office
              </span>

              <p class="text-dark mb-0">
                {{ employee.office?.officeName }}
              </p>
            </div>

            <!-- <ng-container *ngIf="!isViewedEmployeeBusinessOwner">
              <div class="d-flex align-items-center justify-content-between mb-3">
                <span>
                  <i class="ti ti-user me-2"></i>
                  Manager
                </span>

                <p class="text-dark mb-0">
                  {{ manager }}
                </p>
              </div>

              <div class="d-flex align-items-center justify-content-between mb-3">
                <span>
                  <i class="ti ti-user me-2"></i>
                  Request Manager
                </span>

                <p class="text-dark mb-0">
                  {{ requestManager }}
                </p>
              </div>
            </ng-container> -->

            <div class="d-flex align-items-center justify-content-between">
              <span>
                <i class="ti ti-map-pin me-2"></i>
                Address
              </span>

              <p class="text-dark mb-0" [innerHTML]="getFullAddress(selfMember)">
                {{ getFullAddress(selfMember) }}
              </p>
            </div>
          </div>
        </div>

        <!-- SYSTEM INFORMATION CARD -->

        <div class="card mb-3">
          <div class="card-body">
            <h6 class="mb-3">System Information</h6>

            <div class="d-flex justify-content-between mb-3">
              <span>
                <i class="ti ti-user me-2"></i>
                Created By
              </span>

              <p class="text-dark mb-0">
                {{ employee.createdByUser?.firstName }}
                {{ employee.createdByUser?.lastName }}
              </p>
            </div>

            <div class="d-flex justify-content-between mb-3">
              <span>
                <i class="ti ti-calendar me-2"></i>
                Created On
              </span>

              <p class="text-dark mb-0">
                {{ employee.createdAt | date: 'medium' }}
              </p>
            </div>

            <div class="d-flex justify-content-between mb-3">
              <span>
                <i class="ti ti-user-edit me-2"></i>
                Last Modified By
              </span>

              <p class="text-dark mb-0">
                {{ employee.lastModifiedByUser?.firstName }}
                {{ employee.lastModifiedByUser?.lastName }}
              </p>
            </div>

            <div class="d-flex justify-content-between">
              <span>
                <i class="ti ti-user-edit me-2"></i>
                Last Modified On
              </span>

              <p class="text-dark mb-0">
                {{ employee.lastModifiedOn | date: 'medium' }}
              </p>
            </div>
          </div>
        </div>

        <!-- PERSONAL INFORMATION CARD -->

        <!-- <div class="card mb-3" *ngIf="selfMember$ | async as self">
          <div class="card-body">
            <div class="d-flex justify-content-between mb-3">
              <h6>Personal Information</h6>

              <a class="btn btn-icon btn-sm" (click)="openBusinessModal(personalModal, selfMember)">
                <i class="ti ti-edit"></i>
              </a>
            </div>

            <div class="d-flex justify-content-between mb-3">
              <span>
                <i class="ti ti-e-passport me-2"></i>
                Passport No
              </span>

              <p class="mb-0 text-dark">
                {{ self.passport || 'N/A' }}
              </p>
            </div>

            <div class="d-flex justify-content-between mb-3">
              <span>
                <i class="ti ti-calendar-x me-2"></i>
                Passport Exp Date
              </span>

              <p class="mb-0 text-dark">
                {{ self.passportExpiryDate | date }}
              </p>
            </div>

            <div class="d-flex justify-content-between mb-3">
              <span>
                <i class="ti ti-e-passport me-2"></i>
                PF UAN
              </span>
              <p class="mb-0 text-dark">{{ self.pfUAN || 'N/A' }}</p>
            </div>
            <div class="d-flex justify-content-between mb-3">
              <span>
                <i class="ti ti-e-passport me-2"></i>
                ESI No
              </span>
              <p class="mb-0 text-dark">{{ self.esiNumber || 'N/A' }}</p>
            </div>

            <div class="d-flex justify-content-between mb-3">
              <span>
                <i class="ti ti-gender-male me-2"></i>
                Nationality
              </span>
              <p class="mb-0 text-dark">{{ self.nationality || 'N/A' }}</p>
            </div>
            <div class="d-flex justify-content-between mb-3">
              <span>
                <i class="ti ti-bookmark-plus me-2"></i>
                Religion
              </span>
              <p class="mb-0 text-dark">{{ self.religion || 'N/A' }}</p>
            </div>
            <div class="d-flex justify-content-between mb-3">
              <span>
                <i class="ti ti-hotel-service me-2"></i>
                Marital status
              </span>
              <p class="mb-0 text-dark">{{ self.maritalStatus || 'N/A' }}</p>
            </div>
            <div class="d-flex justify-content-between mb-3">
              <span>
                <i class="ti ti-briefcase-2 me-2"></i>
                Employment of spouse
              </span>
              <p class="mb-0 text-dark">
                {{ self.isSpouseEmployed === true ? 'Yes' : 'No' }}
              </p>
            </div>

            <div class="d-flex justify-content-between mb-3">
              <span>
                <i class="ti ti-baby-bottle me-2"></i>
                No. of Children
              </span>

              <p class="mb-0 text-dark">
                {{ self.noOfChildren }}
              </p>
            </div>
          </div>
        </div> -->

        <div class="card mb-3">
          <div class="card-body">
            <div class="d-flex justify-content-between mb-3">
              <h6>Personal Information</h6>

              <a class="btn btn-icon btn-sm" (click)="openBusinessModal(personalModal, selfMember)">
                <i class="ti ti-edit"></i>
              </a>
            </div>

            <div class="d-flex justify-content-between mb-3">
              <span>
                <i class="ti ti-e-passport me-2"></i>
                Passport No
              </span>
              <p class="mb-0 text-dark">{{ selfMember?.passport || 'N/A' }}</p>
            </div>

            <div class="d-flex justify-content-between mb-3">
              <span>
                <i class="ti ti-calendar-x me-2"></i>
                Passport Exp Date
              </span>
              <p class="mb-0 text-dark">
                <!-- {{
                  selfMember?.passportExpiryDate ? (selfMember?.passportExpiryDate | date) : 'N/A'
                }} -->
                {{
                  selfMember?.passportExpiryDate
                    ? (selfMember?.passportExpiryDate | date: 'mediumDate')
                    : 'N/A'
                }}
              </p>
            </div>

            <div class="d-flex justify-content-between mb-3">
              <span>
                <i class="ti ti-e-passport me-2"></i>
                PF UAN
              </span>
              <p class="mb-0 text-dark">{{ selfMember?.pfUAN || 'N/A' }}</p>
            </div>

            <div class="d-flex justify-content-between mb-3">
              <span>
                <i class="ti ti-e-passport me-2"></i>
                ESI No
              </span>
              <p class="mb-0 text-dark">{{ selfMember?.esiNumber || 'N/A' }}</p>
            </div>

            <div class="d-flex justify-content-between mb-3">
              <span>
                <i class="ti ti-gender-male me-2"></i>
                Nationality
              </span>
              <p class="mb-0 text-dark">{{ selfMember?.nationality || 'N/A' }}</p>
            </div>

            <div class="d-flex justify-content-between mb-3">
              <span>
                <i class="ti ti-bookmark-plus me-2"></i>
                Religion
              </span>
              <p class="mb-0 text-dark">{{ selfMember?.religion || 'N/A' }}</p>
            </div>

            <div class="d-flex justify-content-between mb-3">
              <span>
                <i class="ti ti-hotel-service me-2"></i>
                Marital status
              </span>
              <p class="mb-0 text-dark">{{ selfMember?.maritalStatus || 'N/A' }}</p>
            </div>

            <div class="d-flex justify-content-between mb-3">
              <span>
                <i class="ti ti-briefcase-2 me-2"></i>
                Employment of spouse
              </span>
              <p class="mb-0 text-dark">
                {{ selfMember?.isSpouseEmployed === true ? 'Yes' : 'No' }}
              </p>
            </div>

            <div class="d-flex justify-content-between mb-3">
              <span>
                <i class="ti ti-baby-bottle me-2"></i>
                No. of Children
              </span>
              <p class="mb-0 text-dark">{{ selfMember?.noOfChildren ?? 0 }}</p>
            </div>
          </div>
        </div>

        <!-- EMERGENCY CONTACT TITLE -->

        <div class="d-flex align-items-center justify-content-between mb-2 d-none">
          <h6>Emergency Contact Details</h6>

          <a class="btn btn-icon btn-sm">
            <i class="ti ti-edit"></i>
          </a>
        </div>

        <!-- EMERGENCY CARD -->

        <div class="card d-none">
          <div class="card-body">
            <!-- Primary -->

            <div class="border-bottom pb-3 mb-3">
              <span> Primary </span>

              <h6 class="mt-2">
                {{ employee.emergencyContact?.nameP }}

                <i class="ti ti-point-filled text-danger mx-1"></i>

                {{ employee.emergencyContact?.relationshipP }}
              </h6>

              <p class="mb-0">
                {{ employee.emergencyContact?.phoneP }}
              </p>
            </div>

            <!-- Secondary -->

            <div>
              <span> Secondary </span>

              <h6 class="mt-2">
                {{ employee.emergencyContact?.nameS }}

                <i class="ti ti-point-filled text-danger mx-1"></i>

                {{ employee.emergencyContact?.relationshipS }}
              </h6>

              <p class="mb-0">
                {{ employee.emergencyContact?.phoneS }}
              </p>
            </div>
          </div>
        </div>

        <div class="d-flex align-items-center justify-content-between mb-2">
          <h6>Emergency Contact Details</h6>
          <a
            href="javascript:void(0);"
            class="btn btn-icon btn-sm"
            *appHasPermission="[{ employees: ['edit'] }]"
            (click)="openBusinessModal(EmergencyContactModal, employee.emergencyContact)"
            ><i class="ti ti-edit"></i
          ></a>
        </div>
        <div class="card">
          <div class="card-body p-0">
            <ng-container *ngIf="employee$ | async as employee">
              <div *ngIf="employee?.emergencyContact; else noEmergencyContact">
                <div class="p-3 border-bottom">
                  <div class="d-flex align-items-center justify-content-between">
                    <div>
                      <span class="d-inline-flex align-items-center"> Primary </span>
                      <h6 class="d-flex align-items-center fw-medium mt-1">
                        {{ employee.emergencyContact ? employee.emergencyContact.nameP : '' }}
                        <span class="d-inline-flex mx-1"
                          ><i class="ti ti-point-filled text-danger"></i
                        ></span>
                        {{
                          employee.emergencyContact ? employee.emergencyContact.relationshipP : ''
                        }}
                      </h6>
                    </div>
                    <p class="text-dark">
                      {{ employee.emergencyContact ? employee.emergencyContact.phoneP : '' }}
                    </p>
                  </div>
                </div>
                <div class="p-3 border-bottom">
                  <div class="d-flex align-items-center justify-content-between">
                    <div>
                      <span class="d-inline-flex align-items-center"> Secondary </span>
                      <h6 class="d-flex align-items-center fw-medium mt-1">
                        {{ employee.emergencyContact ? employee.emergencyContact.nameS : '' }}
                        <span class="d-inline-flex mx-1"
                          ><i class="ti ti-point-filled text-danger"></i></span
                        >{{
                          employee.emergencyContact ? employee.emergencyContact.relationshipS : ''
                        }}
                      </h6>
                    </div>
                    <p class="text-dark">
                      {{ employee.emergencyContact ? employee.emergencyContact.phoneS : '' }}
                    </p>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-template #noEmergencyContact>
              <div class="p-3 border-bottom">
                <div class="d-flex align-items-center justify-content-between">
                  Record not available.
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="col-xl-8">
        <div>
          <div class="tab-content custom-accordion-items">
            <div class="tab-pane active show" id="bottom-justified-tab1" role="tabpanel">
              <div class="accordion accordions-items-seperate" id="accordionExample">
                <div class="accordion-item">
                  <div class="accordion-header" id="headingOne">
                    <div class="accordion-button">
                      <div class="d-flex align-items-center flex-fill justify-content-between">
                        <h5>About Employee</h5>
                        <!-- <a href="javascript:void(0)" class="btn btn-sm btn-icon ms-auto" data-bs-toggle="modal"
                          data-bs-target="#edit_employee">
                          <i class="ti ti-edit"></i>
                        </a> -->
                        <a
                          href="#"
                          class="d-flex align-items-center collapsed collapse-arrow"
                          data-bs-toggle="collapse"
                          data-bs-target="#primaryBorderOne"
                          aria-expanded="false"
                          aria-controls="primaryBorderOne"
                        >
                          <i class="ti ti-chevron-down fs-18"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    id="primaryBorderOne"
                    class="accordion-collapse collapse show border-top"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <div class="accordion-body mt-2">
                      {{ employee.about }}
                      <!-- As an award winning designer, I deliver exceptional quality work and bring value to your brand! With
                      10 years of experience and 350+ projects completed worldwide with satisfied customers, I developed
                      the 360° brand approach, which helped me to create numerous brands that are relevant, meaningful and
                      loved. -->
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <div class="accordion-header" id="headingAdditionalInfo">
                    <div class="accordion-button">
                      <div class="d-flex align-items-center flex-fill justify-content-between">
                        <h5>Additional Information</h5>
                        <!-- <a href="javascript:void(0)" class="btn btn-sm btn-icon ms-auto" data-bs-toggle="modal"
                          data-bs-target="#edit_employee">
                          <i class="ti ti-edit"></i>
                        </a> -->
                        <a
                          href="#"
                          class="d-flex align-items-center collapsed collapse-arrow"
                          data-bs-toggle="collapse"
                          data-bs-target="#primaryBorderOneAdditionalInfo"
                          aria-expanded="false"
                          aria-controls="primaryBorderOneAdditionalInfo"
                        >
                          <i class="ti ti-chevron-down fs-18"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    id="primaryBorderOneAdditionalInfo"
                    class="accordion-collapse collapse border-top"
                    aria-labelledby="headingAdditionalInfo"
                    data-bs-parent="#accordionExample"
                  >
                    <div class="accordion-body mt-2">
                      <div
                        class="d-flex align-items-center justify-content-between mb-2"
                        *ngIf="selfMember$ | async as self"
                      >
                        <span class="d-inline-flex align-items-center">
                          <i class="ti ti-e-passport me-2"></i>
                          Aadhar No
                        </span>
                        <p class="text-dark">{{ self.aadharNo }}</p>
                      </div>
                      <div
                        class="d-flex align-items-center justify-content-between mb-2"
                        *ngIf="selfMember$ | async as self"
                      >
                        <span class="d-inline-flex align-items-center">
                          <i class="ti ti-e-passport me-2"></i>
                          PAN
                        </span>
                        <p class="text-dark">{{ self.PAN }}</p>
                      </div>
                      <!-- As an award winning designer, I deliver exceptional quality work and bring value to your brand! With
                      10 years of experience and 350+ projects completed worldwide with satisfied customers, I developed
                      the 360° brand approach, which helped me to create numerous brands that are relevant, meaningful and
                      loved. -->
                    </div>
                  </div>
                </div>
                <div class="accordion-item" *ngIf="(offboardingList?.length ?? 0) > 0">
                  <div class="accordion-header" id="headingSix">
                    <div class="accordion-button">
                      <div class="d-flex align-items-center justify-content-between flex-fill">
                        <h5>Off Boarding Information</h5>
                        <div class="d-flex">
                          <!-- <a
                            href="javascript:void(0)"
                            class="btn btn-sm btn-icon ms-auto"
                            (click)="openBusinessModal(offBoardModal, '')"
                            *appHasPermission="[{ employees: ['edit'] }]"
                            ><i class="ti ti-plus"></i
                          ></a> -->
                          <a
                            href="javascript:void(0)"
                            class="d-flex align-items-center collapsed collapse-arrow"
                            data-bs-toggle="collapse"
                            data-bs-target="#primaryBorderSix"
                            aria-expanded="false"
                            aria-controls="primaryBorderSix"
                            (click)="onOffBoardTabClick($event)"
                          >
                            <i class="ti ti-chevron-down fs-18"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="primaryBorderSix"
                    class="accordion-collapse collapse border-top"
                    aria-labelledby="headingSix"
                    data-bs-parent="#accordionExample"
                  >
                    <div class="accordion-body">
                      <ng-container *ngIf="offboardingList as offboardings">
                        <div *ngIf="offboardings.length > 0; else noBankDetail">
                          <div class="row" *ngFor="let offBoard of offboardings">
                            <div class="col-md-3">
                              <span class="d-inline-flex align-items-center"> Date </span>
                              <h6 class="d-flex align-items-center fw-medium mt-1">
                                {{ offBoard.date | date: 'mediumDate' }}
                              </h6>
                            </div>
                            <div class="col-md-3">
                              <span class="d-inline-flex align-items-center"> Approver </span>
                              <h6 class="d-flex align-items-center fw-medium mt-1">
                                {{ offBoard.approver.firstName }} {{ offBoard.approver.lastName }}
                              </h6>
                            </div>
                            <div class="col-md-2">
                              <span class="d-inline-flex align-items-center"> Status </span>
                              <h6 class="d-flex align-items-center fw-medium mt-1">
                                {{ offBoard.status }}
                              </h6>
                            </div>
                            <!-- <div class="col-md-3">
                              <span class="d-inline-flex align-items-center"> Branch </span>
                              <h6 class="d-flex align-items-center fw-medium mt-1">
                                {{ bank.branch }}
                              </h6>
                            </div> -->
                            <div class="col-md-2">
                              <span class="d-inline-flex align-items-center">
                                Off Boarding Type
                              </span>
                              <h6 class="d-flex align-items-center fw-medium mt-1">
                                {{ offBoard.offboardingType || 'N/A' }}
                              </h6>
                            </div>
                            <div class="col-md-1">
                              <div class="d-flex flex-column">
                                <span class="d-inline-flex align-item-center"> Action </span>
                                <div class="d-flex align-items-center">
                                  <a
                                    href="javascript:void(0);"
                                    *appHasPermission="[{ offBoarding: ['edit'] }]"
                                    (click)="openBusinessModal(offBoardModal, offBoard)"
                                    class="d-inline-flex align-items-center me-2"
                                    ><i class="ti ti-edit"></i
                                  ></a>
                                  <a
                                    href="javascript:void(0);"
                                    *appHasPermission="[{ employees: ['delete'] }]"
                                    (click)="openDeleteModal(offBoard.id, 'offBoard')"
                                  >
                                    <i class="ti ti-trash"></i>
                                  </a>
                                </div>
                                <!-- <a
                                href="javascript:void(0);"
                                class="me-2"
                                (click)="setAsDefault(bank)"
                                ><i
                                [ngClass]="
                                bank.isDefault
                                ? 'ti ti-star-filled filled text-primary'
                                : 'ti ti-star'
                                "
                                ></i>
                              </a> -->
                                <!-- <a
                              href="javascript:void(0);"
                              *appHasPermission="{ user: ['status'] }"
                              class="d-inline-flex align-items-center"
                              ><i></i
                                ></a> -->
                                <!-- <a
                                href="javascript:void(0);"
                                *appHasPermission="[{ employees: ['delete'] }]"
                                (click)="openDeleteModal(bank.id, 'bank')"
                                ><i class="ti ti-trash"></i
                                  ></a> -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <ng-template #noBankDetail> Record not available. </ng-template>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <div class="accordion-header" id="headingTwo">
                    <div class="accordion-button">
                      <div class="d-flex align-items-center justify-content-between flex-fill">
                        <h5>Bank Information</h5>
                        <div class="d-flex">
                          <a
                            href="javascript:void(0)"
                            class="btn btn-sm btn-icon ms-auto me-2"
                            (click)="openBusinessModal(BankModal, '')"
                            *appHasPermission="[{ employees: ['edit'] }]"
                            ><i class="ti ti-plus"></i
                          ></a>
                          <a
                            href="#"
                            class="d-flex align-items-center collapsed collapse-arrow"
                            data-bs-toggle="collapse"
                            data-bs-target="#primaryBorderTwo"
                            aria-expanded="false"
                            aria-controls="primaryBorderTwo"
                            (click)="onBankTabClick($event)"
                          >
                            <i class="ti ti-chevron-down fs-18"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="primaryBorderTwo"
                    class="accordion-collapse collapse border-top"
                    aria-labelledby="headingTwo"
                    data-bs-parent="#accordionExample"
                  >
                    <!-- <div class="accordion-body">
                      <ng-container *ngIf="banks$ | async as banks">
                        <div *ngIf="banks.length > 0; else noBankDetail">
                          <div class="row" *ngFor="let bank of banks">
                            <div class="col-md-3">
                              <span class="d-inline-flex align-items-center"> Bank Name </span>
                              <h6 class="d-flex align-items-center fw-medium mt-1">
                                {{ bank.bank }}
                              </h6>
                            </div>
                            <div class="col-md-3">
                              <span class="d-inline-flex align-items-center">
                                Bank Account No
                              </span>
                              <h6 class="d-flex align-items-center fw-medium mt-1">
                                {{ bank.accountNo }}
                              </h6>
                            </div>
                            <div class="col-md-2">
                              <span class="d-inline-flex align-items-center"> IFS Code </span>
                              <h6 class="d-flex align-items-center fw-medium mt-1">
                                {{ bank.ifsc }}
                              </h6>
                            </div>
                            <div class="col-md-3">
                              <span class="d-inline-flex align-items-center"> Branch </span>
                              <h6 class="d-flex align-items-center fw-medium mt-1">
                                {{ bank.branch }}
                              </h6>
                            </div>
                            <div class="col-md-1">
                              <a
                                href="javascript:void(0);"
                                *appHasPermission="[{ employees: ['edit'] }]"
                                (click)="openBusinessModal(BankModal, bank)"
                                class="d-inline-flex align-items-center me-2"
                                ><i class="ti ti-edit"></i
                              ></a>
                              <a
                                href="javascript:void(0);"
                                class="me-2"
                                (click)="setAsDefault(bank)"
                                ><i
                                  [ngClass]="
                                    bank.isDefault
                                      ? 'ti ti-star-filled filled text-primary'
                                      : 'ti ti-star'
                                  "
                                ></i>
                              </a> -->
                    <!-- <a
                            href="javascript:void(0);"
                            *appHasPermission="{ user: ['status'] }"
                            class="d-inline-flex align-items-center"
                            ><i></i
                          ></a> -->
                    <!-- <a
                                href="javascript:void(0);"
                                *appHasPermission="[{ employees: ['delete'] }]"
                                (click)="openDeleteModal(bank.id, 'bank')"
                                ><i class="ti ti-trash"></i
                              ></a>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <ng-template #noBankDetail> Record not available. </ng-template>
                    </div> -->
                    <div class="accordion-body">
                      <ng-container *ngIf="banks$ | async as banks">
                        <div *ngIf="banks.length > 0; else noBankDetail">
                          <div class="row fw-bold mb-2">
                            <div class="col-md-3">Bank Name</div>
                            <div class="col-md-2">Bank Account No</div>
                            <div class="col-md-2">IFS Code</div>
                            <div class="col-md-3">Branch</div>
                            <ng-container
                              *appHasPermission="[
                                { bankDetail: ['edit'] },
                                { bankDetail: ['delete'] }
                              ]"
                            >
                              <div class="col-md-2">Action</div>
                            </ng-container>
                          </div>

                          <div class="row mb-2" *ngFor="let bank of banks">
                            <div class="col-md-3">
                              {{ bank.bank }}
                            </div>
                            <div class="col-md-2">
                              {{ bank.accountNo }}
                            </div>
                            <div class="col-md-2">
                              {{ bank.ifsc }}
                            </div>
                            <div class="col-md-3">
                              {{ bank.branch }}
                            </div>
                            <div class="col-md-2 d-flex align-items-center flex-wrap gap-2">
                              <a
                                href="javascript:void(0);"
                                *appHasPermission="[{ bankDetail: ['edit'] }]"
                                (click)="openBusinessModal(BankModal, bank)"
                              >
                                <i class="ti ti-edit"></i>
                              </a>

                              <a
                                href="javascript:void(0);"
                                *appHasPermission="[{ bankDetail: ['edit'] }]"
                                (click)="setAsDefault(bank)"
                              >
                                <i
                                  [ngClass]="
                                    bank.isDefault
                                      ? 'ti ti-star-filled filled text-primary'
                                      : 'ti ti-star'
                                  "
                                >
                                </i>
                              </a>

                              <a
                                href="javascript:void(0);"
                                *appHasPermission="[{ bankDetail: ['delete'] }]"
                                (click)="openDeleteModal(bank.id, 'bank')"
                              >
                                <i class="ti ti-trash"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <ng-template #noBankDetail> Record not available. </ng-template>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <div class="accordion-header" id="headingThree">
                    <div class="accordion-button">
                      <div class="d-flex align-items-center justify-content-between flex-fill">
                        <h5>Family Information</h5>
                        <div class="d-flex">
                          <a
                            href="javascript:void(0);"
                            class="btn btn-icon btn-sm me-2"
                            *appHasPermission="[{ employees: ['edit'] }]"
                            (click)="openBusinessModal(FamilyMemberModal, '')"
                            ><i class="ti ti-plus"></i
                          ></a>
                          <!-- <a href="#" class="btn btn-icon btn-sm" data-bs-toggle="modal"
                            data-bs-target="#edit_familyinformation"><i class="ti ti-edit"></i></a> -->
                          <a
                            href="#"
                            class="d-flex align-items-center collapsed collapse-arrow"
                            data-bs-toggle="collapse"
                            data-bs-target="#primaryBorderThree"
                            aria-expanded="false"
                            aria-controls="primaryBorderThree"
                          >
                            <i class="ti ti-chevron-down fs-18"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="primaryBorderThree"
                    class="accordion-collapse collapse border-top"
                    aria-labelledby="headingThree"
                    data-bs-parent="#accordionExample"
                  >
                    <div class="accordion-body">
                      <ng-container *ngIf="familyMembers$ | async as familyMembers">
                        <div *ngIf="familyMembers.length > 0; else noFamily">
                          <div *ngFor="let family of familyMembers" class="row mb-2">
                            <div class="col-md-4">
                              <span class="d-inline-flex align-items-center"> Name </span>
                              <h6 class="d-flex align-items-center fw-medium mt-1">
                                {{ family.name || 'N/A' }}
                              </h6>
                            </div>
                            <div class="col-md-2">
                              <span class="d-inline-flex align-items-center"> Relationship </span>
                              <h6 class="d-flex align-items-center fw-medium mt-1">
                                {{ family.relation || 'N/A' }}
                              </h6>
                            </div>
                            <div class="col-md-2">
                              <span class="d-inline-flex align-items-center"> Date of birth </span>
                              <h6 class="d-flex align-items-center fw-medium mt-1">
                                {{
                                  family.birthdate ? (family.birthdate | date: 'mediumDate') : 'N/A'
                                }}
                              </h6>
                            </div>
                            <div class="col-md-3">
                              <span class="d-inline-flex align-items-center"> Mobile </span>
                              <h6 class="d-flex align-items-center fw-medium mt-1">
                                {{ family.mobile || 'N/A' }}
                              </h6>
                            </div>
                            <div class="col-md-1">
                              <a
                                href="javascript:void(0);"
                                *appHasPermission="[{ employees: ['edit'] }]"
                                class="d-inline-flex align-items-center me-2"
                                (click)="openBusinessModal(FamilyMemberModal, family)"
                              >
                                <i class="ti ti-edit"></i>
                              </a>
                              <a
                                href="javascript:void(0);"
                                class="d-inline-flex align-items-center"
                                *appHasPermission="[{ employees: ['edit'] }]"
                                (click)="openDeleteModal(family.id, 'family')"
                              >
                                <i class="ti ti-trash"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <ng-template #noFamily>
                        <div p-3 border-bottom>Record not available.</div>
                      </ng-template>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="accordion-item">
                      <div class="row">
                        <div class="accordion-header" id="headingFour">
                          <div class="accordion-button">
                            <div
                              class="d-flex align-items-center justify-content-between flex-fill"
                            >
                              <h5>Education Details</h5>
                              <div class="d-flex">
                                <a
                                  href="javascript:void(0);"
                                  class="btn btn-icon btn-sm me-2"
                                  *appHasPermission="[{ employees: ['edit'] }]"
                                  (click)="openBusinessModal(addEducationModal, '')"
                                  ><i class="ti ti-plus"></i
                                ></a>
                                <a
                                  href="javascript:void(0);"
                                  class="d-flex align-items-center collapsed collapse-arrow"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#primaryBorderFour"
                                  aria-expanded="false"
                                  aria-controls="primaryBorderFour"
                                  (click)="onEducationTabClick($event)"
                                >
                                  <i class="ti ti-chevron-down fs-18"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          id="primaryBorderFour"
                          class="accordion-collapse collapse border-top"
                          aria-labelledby="headingFour"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <div>
                              <ng-container *ngIf="educations$ | async as educations">
                                <div *ngIf="educations.length > 0; else noEducation">
                                  <div class="mb-3" *ngFor="let education of educations">
                                    <div class="d-flex align-items-center justify-content-between">
                                      <div class="w-50">
                                        <span
                                          class="d-inline-flex align-items-center fw-normal"
                                          style="white-space: normal; word-break: break-word"
                                        >
                                          {{ education.university | capitalize }}
                                        </span>
                                        <h6
                                          class="d-flex align-items-center mt-1"
                                          style="white-space: normal; word-break: break-word"
                                        >
                                          {{ education.degree }}
                                        </h6>
                                      </div>
                                      <p class="text-dark">
                                        {{ education.startDate | date: 'yyyy' }} -
                                        {{ education.endDate | date: 'yyyy' }}
                                      </p>
                                      <div>
                                        <a
                                          href="javascript:void(0);"
                                          *appHasPermission="[{ employees: ['edit'] }]"
                                          (click)="openBusinessModal(addEducationModal, education)"
                                          class="d-inline-flex align-items-center me-2"
                                          ><i class="ti ti-edit"></i
                                        ></a>
                                        <a
                                          href="javascript:void(0);"
                                          *appHasPermission="[{ employees: ['delete'] }]"
                                          (click)="openDeleteModal(education.id, 'education')"
                                          class="d-inline-flex align-items-center"
                                          ><i class="ti ti-trash"></i
                                        ></a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </ng-container>
                              <ng-template #noEducation>
                                <div class="mb-3">
                                  <div class="d-flex align-items-center justify-content-between">
                                    Record not available.
                                  </div>
                                </div>
                              </ng-template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="accordion-item">
                      <div class="row">
                        <div class="accordion-header" id="headingFive">
                          <div class="accordion-button collapsed">
                            <div
                              class="d-flex align-items-center justify-content-between flex-fill"
                            >
                              <h5>Experience</h5>
                              <div class="d-flex">
                                <a
                                  href="javascript:void(0);"
                                  class="btn btn-icon btn-sm me-2"
                                  (click)="openBusinessModal(addExperienceModal, '')"
                                  *appHasPermission="[{ employees: ['edit'] }]"
                                  ><i class="ti ti-plus"></i
                                ></a>
                                <a
                                  href="javascript:void(0);"
                                  class="d-flex align-items-center collapsed collapse-arrow"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#primaryBorderFive"
                                  aria-expanded="false"
                                  aria-controls="primaryBorderFive"
                                >
                                  <i class="ti ti-chevron-down fs-18"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          id="primaryBorderFive"
                          class="accordion-collapse collapse border-top"
                          aria-labelledby="headingFive"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <div>
                              <ng-container *ngIf="experiences$ | async as experiences">
                                <div *ngIf="experiences.length > 0; else noExperience">
                                  <div class="mb-3" *ngFor="let experience of experiences">
                                    <div class="d-flex align-items-center justify-content-between">
                                      <div>
                                        <span class="d-inline-flex align-items-center fw-normal"
                                          >{{ experience.company | capitalize }}
                                        </span>
                                        <h6 class="d-flex align-items-center mt-1">
                                          {{ experience.designation | capitalize }}
                                        </h6>
                                      </div>
                                      <p class="text-dark">
                                        {{ experience.startDate | date: 'mediumDate' }}
                                        <span *ngIf="experience.isPresent"> - Present</span>
                                        <span *ngIf="!experience.isPresent">
                                          - {{ experience.endDate | date: 'mediumDate' }}</span
                                        >
                                      </p>
                                      <div>
                                        <a
                                          href="javascript:void(0);"
                                          *appHasPermission="[{ employees: ['edit'] }]"
                                          (click)="
                                            openBusinessModal(addExperienceModal, experience)
                                          "
                                          class="d-inline-flex align-items-center me-2"
                                          ><i class="ti ti-edit"></i
                                        ></a>
                                        <a
                                          href="javascript:void(0);"
                                          *appHasPermission="[{ employees: ['delete'] }]"
                                          (click)="openDeleteModal(experience.id, 'experience')"
                                          class="d-inline-flex align-items-center"
                                          ><i class="ti ti-trash"></i
                                        ></a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </ng-container>
                              <ng-template #noExperience>
                                <div class="mb-3">
                                  <div class="d-flex align-items-center justify-content-between">
                                    Record not available.
                                  </div>
                                </div>
                              </ng-template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-body">
                    <div class="contact-grids-tab p-0 mb-3">
                      <ul class="nav nav-underline" id="myTab" role="tablist">
                        <li class="nav-item" role="presentation">
                          <!-- <button
                            class="nav-link active"
                            id="info-tab-policies2"
                            data-bs-toggle="tab"
                            data-bs-target="#basic-info-policies2"
                            type="button"
                            role="tab"
                            aria-selected="true"
                          >
                            Attendance Policy
                          </button> -->
                          <button
                            class="nav-link"
                            [ngClass]="{ active: activeTab === 'attendance' }"
                            id="info-tab-policies2"
                            data-bs-toggle="tab"
                            data-bs-target="#basic-info-policies2"
                            type="button"
                            role="tab"
                            aria-selected="true"
                          >
                            Attendance Policy
                          </button>
                        </li>
                        <li class="nav-item" role="presentation">
                          <!-- <button
                            class="nav-link"
                            id="info-tab-policies3"
                            data-bs-toggle="tab"
                            data-bs-target="#basic-info-policies3"
                            type="button"
                            role="tab"
                            aria-selected="true"
                          >
                            Leave Policies
                          </button> -->
                          <button
                            class="nav-link"
                            [ngClass]="{ active: activeTab === 'leave' }"
                            id="info-tab-policies3"
                            data-bs-toggle="tab"
                            data-bs-target="#basic-info-policies3"
                            type="button"
                            role="tab"
                            aria-selected="true"
                            (click)="onLeavePolicyTabClick($event)"
                          >
                            Leave Policies
                          </button>
                        </li>
                        <li
                          class="nav-item"
                          role="presentation"
                          *appHasPermission="{ permissionSet: ['view'] }"
                        >
                          <button
                            class="nav-link"
                            id="info-tab-roles"
                            data-bs-toggle="tab"
                            data-bs-target="#basic-info-roles"
                            type="button"
                            role="tab"
                            aria-selected="true"
                            (click)="onPermissionSetTabClick($event)"
                          >
                            Permission Sets
                          </button>
                        </li>
                        <!-- <li class="nav-item" role="presentation">
                        <button
                          class="nav-link"
                          id="info-tab2"
                          data-bs-toggle="tab"
                          data-bs-target="#basic-info2"
                          type="button"
                          role="tab"
                        >
                          Projects <span class="text-danger"> *</span>
                        </button>
                      </li>
                      <li class="nav-item" role="presentation">
                        <button
                          class="nav-link"
                          id="address-tab2"
                          data-bs-toggle="tab"
                          data-bs-target="#address2"
                          type="button"
                          role="tab"
                          aria-selected="false"
                        >
                          Assets <span class="text-danger"> *</span>
                        </button>
                      </li> -->
                        <li
                          class="nav-item"
                          role="presentation"
                          *appHasPermission="[{ employeeSalary: ['view'] }]"
                        >
                          <button
                            class="nav-link"
                            id="salary-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#salary"
                            type="button"
                            role="tab"
                            aria-selected="false"
                            (click)="onSalaryTabClick($event)"
                          >
                            {{ isContractor(employee) ? 'Payout' : 'Salary' }}
                          </button>
                        </li>
                        <li
                          class="nav-item"
                          role="presentation"
                          *appHasPermission="{ logs: ['view'] }"
                        >
                          <button
                            class="nav-link"
                            id="info-tab-tasklogs"
                            data-bs-toggle="tab"
                            data-bs-target="#basic-info-tasklogs"
                            type="button"
                            role="tab"
                            aria-selected="true"
                            (click)="onLogsTabClick($event)"
                          >
                            Logs
                          </button>
                        </li>
                      </ul>
                    </div>
                    <div class="tab-content" id="myTabContent3">
                      <!-- <div
                        class="tab-pane fade show active"
                        id="basic-info-policies2"
                        role="tabpanel"
                        aria-labelledby="info-tab-policies2"
                        tabindex="0"
                      > -->
                      <div
                        class="tab-pane fade"
                        [ngClass]="{ 'show active': activeTab === 'attendance' }"
                        id="basic-info-policies2"
                        role="tabpanel"
                        aria-labelledby="info-tab-policies2"
                        tabindex="0"
                      >
                        <!-- Assigned Attendance Policies -->
                        <div class="row" *ngFor="let policy of attendancePolicies$ | async">
                          <div class="col-md-12 d-flex">
                            <div class="card flex-fill">
                              <div class="card-body">
                                <div class="row align-items-center">
                                  <div class="col-md-8">
                                    <div class="d-flex align-items-center">
                                      <div>
                                        <h6 class="mb-1">
                                          <a
                                            href="javascript:void(0)"
                                            data-bs-toggle="offcanvas"
                                            data-bs-target="#offcanvasRightAttendancePolicy"
                                            aria-controls="offcanvasRightAttendancePolicy"
                                            (click)="
                                              prepareAttendancePolicyDrawer(
                                                policy.attendancePolicy,
                                                'Attendance Policy'
                                              )
                                            "
                                          >
                                            {{ policy.attendancePolicy.title }}
                                          </a>
                                        </h6>
                                        <div class="d-flex align-items-center">
                                          <p>
                                            <!-- <span class="text-primary">AST - 001<i
                                                class="ti ti-point-filled text-primary mx-1"></i></span> -->
                                            Assigned on:
                                            {{ policy.createdAt | date: 'medium' }}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-3">
                                    <div>
                                      <span class="mb-1 d-block">Assigned by </span>
                                      <a href="#" class="fw-normal d-flex align-items-center">
                                        <!-- <ng-container
                                        *ngIf="
                                          policy.assignByUser?.picture &&
                                            employeeImages[policy.assignByUser.picture];
                                          else initials
                                        "
                                      >
                                        <img
                                          [src]="employeeImages[policy.assignByUser.picture]"
                                          (error)="onImageError(employee)"
                                          class="img-fluid rounded-circle"
                                          alt="img"
                                          style="width: 100%; height: 100%; object-fit: cover"
                                        />
                                      </ng-container> -->
                                        <ng-container
                                          *ngIf="
                                            policy.assignByUser?.picture &&
                                              policy.assignByUser.picture;
                                            else initials
                                          "
                                        >
                                          <img
                                            [src]="
                                              apiEndpoint +
                                              '/uploads/' +
                                              policy.assignByUser.picture
                                            "
                                            class="img-fluid rounded-circle me-2"
                                            style="width: 30px; height: 30px"
                                            alt="img"
                                          />
                                        </ng-container>

                                        <ng-template #initials>
                                          <span
                                            class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold me-2"
                                            style="width: 30px; height: 30px"
                                            >{{
                                              getInitials(
                                                policy.assignByUser?.firstName,
                                                policy.assignByUser?.lastName
                                              )
                                            }}</span
                                          >
                                        </ng-template>
                                        {{ policy.assignByUser?.firstName | capitalize }}
                                        {{ policy.assignByUser?.lastName | capitalize }}
                                      </a>
                                    </div>
                                  </div>
                                  <div class="col-md-1 d-none">
                                    <div class="dropdown ms-2">
                                      <a
                                        href="javascript:void(0);"
                                        class="d-inline-flex align-items-center"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                      >
                                        <i class="ti ti-dots-vertical"></i>
                                      </a>
                                      <ul class="dropdown-menu dropdown-menu-end p-3">
                                        <li>
                                          <a
                                            href="javascript:void(0);"
                                            class="dropdown-item rounded-1"
                                            data-bs-toggle="modal"
                                            data-bs-target="#asset_info"
                                            >View Info</a
                                          >
                                        </li>
                                        <li>
                                          <a
                                            href="javascript:void(0);"
                                            class="dropdown-item rounded-1"
                                            data-bs-toggle="modal"
                                            data-bs-target="#refuse_msg"
                                            >Raise Issue
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- Assigned Leave Policies -->
                      </div>
                      <!-- <div
                        class="tab-pane fade"
                        id="basic-info-policies3"
                        role="tabpanel"
                        aria-labelledby="info-tab-policies3"
                        tabindex="0"
                      > -->
                      <div
                        class="tab-pane fade"
                        [ngClass]="{ 'show active': activeTab === 'leave' }"
                        id="basic-info-policies3"
                        role="tabpanel"
                        aria-labelledby="info-tab-policies3"
                        tabindex="0"
                      >
                        <ng-container *ngIf="leavePolicies.length > 0; else noAssignedPolicies">
                          <div class="row" *ngFor="let policy of leavePolicies">
                            <div class="col-md-12 d-flex">
                              <div class="card flex-fill">
                                <div class="card-body">
                                  <div class="row align-items-center">
                                    <div class="col-md-8">
                                      <div class="d-flex align-items-center">
                                        <div>
                                          <h6 class="mb-1">
                                            <a
                                              href="javascript:void(0)"
                                              data-bs-toggle="offcanvas"
                                              data-bs-target="#offcanvasRightLeavePolicy"
                                              aria-controls="offcanvasRightLeavePolicy"
                                              (click)="
                                                prepareLeavePolicyDrawer(
                                                  policy.leavePolicy,
                                                  'Leave Policy'
                                                )
                                              "
                                            >
                                              {{ policy.leavePolicy?.title }}
                                            </a>
                                          </h6>
                                          <div class="d-flex align-items-center">
                                            <p>
                                              <!-- <span class="text-primary">AST - 001<i
                                                  class="ti ti-point-filled text-primary mx-1"></i></span> -->
                                              Assigned on:
                                              {{ policy.createdAt | date: 'medium' }}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-3">
                                      <div>
                                        <span class="mb-1 d-block">Assigned by </span>
                                        <a href="#" class="fw-normal d-flex align-items-center">
                                          <!-- <img
                                          class="avatar avatar-sm rounded-circle me-2"
                                          src="../../../../assets/img/profiles/avatar-01.jpg"
                                          alt="Img"
                                        /> -->
                                          <!-- <ng-container
                                          *ngIf="
                                            policy.assignedBy?.picture &&
                                              employeeImages[policy.assignedBy.picture];
                                            else initials
                                          "
                                        >
                                          <img
                                            [src]="employeeImages[policy.assignedBy.picture]"
                                            (error)="onImageError(employee)"
                                            class="img-fluid rounded-circle"
                                            alt="img"
                                            style="width: 100%; height: 100%; object-fit: cover"
                                          />
                                        </ng-container> -->
                                          <ng-container
                                            *ngIf="
                                              policy.assignedBy?.picture &&
                                                policy.assignedBy.picture;
                                              else initials
                                            "
                                          >
                                            <img
                                              [src]="
                                                apiEndpoint +
                                                '/uploads/' +
                                                policy.assignedBy.picture
                                              "
                                              class="img-fluid rounded-circle me-2"
                                              style="width: 30px; height: 30px"
                                              alt="img"
                                            />
                                          </ng-container>

                                          <ng-template #initials>
                                            <span
                                              class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold me-2"
                                              style="width: 30px; height: 30px"
                                              >{{
                                                getInitials(
                                                  policy.assignedBy?.firstName,
                                                  policy.assignedBy?.lastName
                                                )
                                              }}</span
                                            >
                                          </ng-template>
                                          {{ policy.assignedBy?.firstName | capitalize }}
                                          {{ policy.assignedBy?.lastName | capitalize }}
                                        </a>
                                      </div>
                                    </div>
                                    <div class="col-md-1 d-none">
                                      <div class="dropdown ms-2">
                                        <a
                                          href="javascript:void(0);"
                                          class="d-inline-flex align-items-center"
                                          data-bs-toggle="dropdown"
                                          aria-expanded="false"
                                        >
                                          <i class="ti ti-dots-vertical"></i>
                                        </a>
                                        <ul class="dropdown-menu dropdown-menu-end p-3">
                                          <li>
                                            <a
                                              href="javascript:void(0);"
                                              class="dropdown-item rounded-1"
                                              data-bs-toggle="modal"
                                              data-bs-target="#asset_info"
                                              >View Info</a
                                            >
                                          </li>
                                          <li>
                                            <a
                                              href="javascript:void(0);"
                                              class="dropdown-item rounded-1"
                                              data-bs-toggle="modal"
                                              data-bs-target="#refuse_msg"
                                              >Raise Issue
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>

                        <ng-template #noAssignedPolicies>
                          <div class="mb-3">
                            <div class="d-flex align-items-center justify-content-between">
                              Record not available.
                            </div>
                          </div>
                        </ng-template>
                      </div>
                      <div
                        class="tab-pane fade"
                        id="basic-info-roles"
                        role="tabpanel"
                        aria-labelledby="info-tab-roles"
                        tabindex="0"
                      >
                        <div class="row">
                          <div class="d-flex justify-content-end">
                            <div class="mb-2" *appHasPermission="[{ employees: ['edit'] }]">
                              <a
                                href="javascript:void(0)"
                                class="btn btn-primary d-flex align-items-center"
                                (click)="
                                  openBusinessModal(
                                    assignPermissionSetsModal,
                                    {},
                                    'assignPermissionSetsModal'
                                  )
                                "
                                ><i class="ti ti-circle-plus me-2"></i>Assign Permission Sets</a
                              >
                            </div>
                          </div>
                          <div class="col-md-12 d-flex" *ngIf="employee.userPermissionSets">
                            <div
                              class="card flex-fill"
                              *ngIf="employee.userPermissionSets.length > 0; else noPermissionSets"
                            >
                              <div class="card-body d-none">
                                <div class="row align-items-center d-none">
                                  <div
                                    class="col-md-8"
                                    *ngFor="let userpermissionSet of employee.userPermissionSets"
                                  >
                                    <div class="d-flex align-items-center">
                                      <!-- <a href="https://smarthr.dreamstechnologies.com/html/template/project-details.html"
                                        class="flex-shrink-0 me-2">
                                        <img
                                          src="https://smarthr.dreamstechnologies.com/html/template/assets/img/products/product-05.jpg"
                                          class="img-fluid rounded-circle" alt="img">
                                      </a> -->
                                      <div>
                                        <h6 class="mb-1">
                                          <a
                                            href="javascript:void(0)"
                                            data-bs-toggle="offcanvas"
                                            data-bs-target="#offcanvasRightRoles"
                                            aria-controls="offcanvasRightRoles"
                                            (click)="
                                              openOffcanvasRoles(userpermissionSet.permissionSet)
                                            "
                                            >{{ userpermissionSet?.permissionSet?.name }}
                                          </a>
                                        </h6>
                                        <div class="d-flex align-items-center">
                                          <p>
                                            <!-- <span class="text-primary">AST - 001<i
                                                class="ti ti-point-filled text-primary mx-1"></i></span> -->
                                            Assigned on
                                            {{ userpermissionSet.createdAt | date: 'medium' }}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-3">
                                    <div>
                                      <span class="mb-1 d-block"
                                        >Assigned by <span class="text-danger">*</span></span
                                      >
                                      <a href="#" class="fw-normal d-flex align-items-center">
                                        <img
                                          class="avatar avatar-sm rounded-circle me-2"
                                          src="../../../../assets/img/profiles/avatar-01.jpg"
                                          alt="Img"
                                        />
                                        Andrew Symon
                                      </a>
                                    </div>
                                  </div>
                                  <div class="col-md-1 d-none">
                                    <div class="dropdown ms-2">
                                      <a
                                        href="javascript:void(0);"
                                        class="d-inline-flex align-items-center"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                      >
                                        <i class="ti ti-dots-vertical"></i>
                                      </a>
                                      <ul class="dropdown-menu dropdown-menu-end p-3">
                                        <li>
                                          <a
                                            href="javascript:void(0);"
                                            class="dropdown-item rounded-1"
                                            data-bs-toggle="modal"
                                            data-bs-target="#asset_info"
                                            >View Info</a
                                          >
                                        </li>
                                        <li>
                                          <a
                                            href="javascript:void(0);"
                                            class="dropdown-item rounded-1"
                                            data-bs-toggle="modal"
                                            data-bs-target="#refuse_msg"
                                            >Raise Issue
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="card-body p-0">
                                <div class="custom-datatable-filter table-responsive">
                                  <ng-container *ngIf="employee.userPermissionSets">
                                    <table
                                      class="table datatable"
                                      *ngIf="employee.userPermissionSets.length > 0; else noRecords"
                                    >
                                      <thead class="thead-light">
                                        <tr>
                                          <th>Name</th>
                                          <th>Valid Upto</th>
                                          <th>Assigned By</th>
                                          <th>Assigned On</th>

                                          <th>Status</th>
                                          <th class="text-end">Action</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr
                                          *ngFor="
                                            let userpermissionSet of employee.userPermissionSets
                                          "
                                        >
                                          <td>{{ userpermissionSet?.permissionSet?.name }}</td>
                                          <td>
                                            {{
                                              userpermissionSet.validUpto
                                                ? (userpermissionSet.validUpto
                                                  | date: 'MMM d, y h:mm a' : '+0530')
                                                : '-'
                                            }}
                                          </td>
                                          <td>
                                            {{
                                              userpermissionSet.assignedBy
                                                ? (userpermissionSet.assignedByUser?.firstName ||
                                                    '') +
                                                  ' ' +
                                                  (userpermissionSet.assignedByUser?.lastName || '')
                                                : 'Administration'
                                            }}
                                          </td>
                                          <td>
                                            {{ userpermissionSet.createdAt | date: 'mediumDate' }}
                                          </td>
                                          <td>
                                            <span
                                              *ngIf="
                                                !userpermissionSet.disabled &&
                                                !isExpired(userpermissionSet.validUpto)
                                              "
                                              class="badge badge-success d-inline-flex align-items-center badge-xs"
                                            >
                                              Active
                                            </span>
                                            <span
                                              *ngIf="
                                                userpermissionSet.disabled ||
                                                isExpired(userpermissionSet.validUpto)
                                              "
                                              class="badge badge-danger d-inline-flex align-items-center badge-xs"
                                            >
                                              Inactive
                                            </span>
                                          </td>
                                          <td class="text-end">
                                            <!-- <div class="action-icon d-inline-flex">
                                            <a
                                              [routerLink]="['/hrm/employee', employee.id]"
                                              class="me-2"
                                              *appHasPermission="{ user: ['view'] }"
                                              ><i class="ti ti-eye"></i
                                            ></a>
                                          </div> -->
                                            <a
                                              href="javascript:void(0);"
                                              class="me-2"
                                              (click)="
                                                openViewPermissionSetModal(
                                                  viewBusinessModals,
                                                  userpermissionSet.permissionSet
                                                )
                                              "
                                              ><i class="ti ti-info-circle text-info"></i
                                            ></a>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </ng-container>
                                  <ng-template #noRecords>
                                    <div class="d-flex align-items-center justify-content-between">
                                      Record not available.
                                    </div>
                                  </ng-template>
                                </div>
                              </div>
                              <!-- pagination -->
                              <!-- <ng-container *ngIf="employees$ | async as employees">
                              <div
                                class="d-flex align-items-center justify-content-between ms-2"
                                *ngIf="employees.length > 0"
                              >
                                <div>
                                  Showing {{ (currentPage - 1) * pageLimit + 1 }} to
                                  {{ pageLastRecord }} of {{ totalCount }} entries
                                </div>
                                <div class="has-text-centered mt-3">
                                  <app-pagination
                                    [currentPage]="currentPage"
                                    [pageSize]="pageLimit"
                                    [totalRows]="totalCount"
                                    (pageChange)="onPageChange($event)"
                                  ></app-pagination>
                                </div>
                              </div>
                            </ng-container> -->
                            </div>
                            <ng-template #noPermissionSets>
                              <div class="mb-3">
                                <div class="d-flex align-items-center justify-content-between">
                                  Record not available.
                                </div>
                              </div>
                            </ng-template>
                          </div>

                          <!-- permission set -->
                        </div>
                      </div>
                      <div
                        class="tab-pane fade"
                        id="basic-info2"
                        role="tabpanel"
                        aria-labelledby="info-tab2"
                        tabindex="0"
                      >
                        <div class="row">
                          <div class="col-md-6 d-flex">
                            <div class="card flex-fill mb-4 mb-md-0">
                              <div class="card-body">
                                <div class="d-flex align-items-center pb-3 mb-3 border-bottom">
                                  <a
                                    href="https://smarthr.dreamstechnologies.com/html/template/project-details.html"
                                    class="flex-shrink-0 me-2"
                                  >
                                    <img
                                      src="https://smarthr.dreamstechnologies.com/html/template/assets/img/social/project-03.svg"
                                      alt="Img"
                                    />
                                  </a>
                                  <div>
                                    <h6 class="mb-1">
                                      <a
                                        href="https://smarthr.dreamstechnologies.com/html/template/project-details.html"
                                        >World Health</a
                                      >
                                    </h6>
                                    <div class="d-flex align-items-center">
                                      <p class="mb-0 fs-13">8 tasks</p>
                                      <p class="fs-13">
                                        <span class="mx-1"
                                          ><i class="ti ti-point-filled text-primary"></i></span
                                        >15 Completed
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-6">
                                    <div>
                                      <span class="mb-1 d-block">Deadline</span>
                                      <p class="text-dark">31 July 2025</p>
                                    </div>
                                  </div>
                                  <div class="col-md-6">
                                    <div>
                                      <span class="mb-1 d-block">Project Lead</span>
                                      <a href="#" class="fw-normal d-flex align-items-center">
                                        <img
                                          class="avatar avatar-sm rounded-circle me-2"
                                          src="../../../../assets/img/profiles/avatar-01.jpg"
                                          alt="Img"
                                        />
                                        Leona
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6 d-flex">
                            <div class="card flex-fill mb-0">
                              <div class="card-body">
                                <div class="d-flex align-items-center pb-3 mb-3 border-bottom">
                                  <a
                                    href="https://smarthr.dreamstechnologies.com/html/template/project-details.html"
                                    class="flex-shrink-0 me-2"
                                  >
                                    <img
                                      src="https://smarthr.dreamstechnologies.com/html/template/assets/img/social/project-01.svg"
                                      alt="Img"
                                    />
                                  </a>
                                  <div>
                                    <h6 class="mb-1 text-truncate">
                                      <a
                                        href="https://smarthr.dreamstechnologies.com/html/template/project-details.html"
                                        >Hospital Administration</a
                                      >
                                    </h6>
                                    <div class="d-flex align-items-center">
                                      <p class="mb-0 fs-13">8 tasks</p>
                                      <p class="fs-13">
                                        <span class="mx-1"
                                          ><i class="ti ti-point-filled text-primary"></i></span
                                        >15 Completed
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-6">
                                    <div>
                                      <span class="mb-1 d-block">Deadline</span>
                                      <p class="text-dark">31 July 2025</p>
                                    </div>
                                  </div>
                                  <div class="col-md-6">
                                    <div>
                                      <span class="mb-1 d-block">Project Lead</span>
                                      <a href="#" class="fw-normal d-flex align-items-center">
                                        <img
                                          class="avatar avatar-sm rounded-circle me-2"
                                          src="../../../../assets/img/profiles/avatar-01.jpg"
                                          alt="Img"
                                        />
                                        Leona
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="tab-pane fade"
                        id="address2"
                        role="tabpanel"
                        aria-labelledby="address-tab2"
                        tabindex="0"
                      >
                        <div class="row">
                          <div class="col-md-12 d-flex">
                            <div class="card flex-fill">
                              <div class="card-body">
                                <div class="row align-items-center">
                                  <div class="col-md-8">
                                    <div class="d-flex align-items-center">
                                      <a
                                        href="https://smarthr.dreamstechnologies.com/html/template/project-details.html"
                                        class="flex-shrink-0 me-2"
                                      >
                                        <img
                                          src="https://smarthr.dreamstechnologies.com/html/template/assets/img/products/product-05.jpg"
                                          class="img-fluid rounded-circle"
                                          alt="img"
                                        />
                                      </a>
                                      <div>
                                        <h6 class="mb-1">
                                          <a
                                            href="https://smarthr.dreamstechnologies.com/html/template/project-details.html"
                                            >Dell Laptop - #343556656</a
                                          >
                                        </h6>
                                        <div class="d-flex align-items-center">
                                          <p>
                                            <span class="text-primary"
                                              >AST - 001<i
                                                class="ti ti-point-filled text-primary mx-1"
                                              ></i></span
                                            >Assigned on 22 Nov, 2022 10:32AM
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-3">
                                    <div>
                                      <span class="mb-1 d-block">Assigned by</span>
                                      <a href="#" class="fw-normal d-flex align-items-center">
                                        <img
                                          class="avatar avatar-sm rounded-circle me-2"
                                          src="../../../../assets/img/profiles/avatar-01.jpg"
                                          alt="Img"
                                        />
                                        Andrew Symon
                                      </a>
                                    </div>
                                  </div>
                                  <div class="col-md-1">
                                    <div class="dropdown ms-2">
                                      <a
                                        href="javascript:void(0);"
                                        class="d-inline-flex align-items-center"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                      >
                                        <i class="ti ti-dots-vertical"></i>
                                      </a>
                                      <ul class="dropdown-menu dropdown-menu-end p-3">
                                        <li>
                                          <a
                                            href="javascript:void(0);"
                                            class="dropdown-item rounded-1"
                                            data-bs-toggle="modal"
                                            data-bs-target="#asset_info"
                                            >View Info</a
                                          >
                                        </li>
                                        <li>
                                          <a
                                            href="javascript:void(0);"
                                            class="dropdown-item rounded-1"
                                            data-bs-toggle="modal"
                                            data-bs-target="#refuse_msg"
                                            >Raise Issue
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12 d-flex">
                            <div class="card flex-fill mb-0">
                              <div class="card-body">
                                <div class="row align-items-center">
                                  <div class="col-md-8">
                                    <div class="d-flex align-items-center">
                                      <a
                                        href="https://smarthr.dreamstechnologies.com/html/template/project-details.html"
                                        class="flex-shrink-0 me-2"
                                      >
                                        <img
                                          src="https://smarthr.dreamstechnologies.com/html/template/assets/img/products/product-06.jpg"
                                          class="img-fluid rounded-circle"
                                          alt="img"
                                        />
                                      </a>
                                      <div>
                                        <h6 class="mb-1">
                                          <a
                                            href="https://smarthr.dreamstechnologies.com/html/template/project-details.html"
                                            >Bluetooth Mouse - #478878</a
                                          >
                                        </h6>
                                        <div class="d-flex align-items-center">
                                          <p>
                                            <span class="text-primary"
                                              >AST - 001<i
                                                class="ti ti-point-filled text-primary mx-1"
                                              ></i></span
                                            >Assigned on 22 Nov, 2022 10:32AM
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-3">
                                    <div>
                                      <span class="mb-1 d-block">Assigned by</span>
                                      <a href="#" class="fw-normal d-flex align-items-center">
                                        <img
                                          class="avatar avatar-sm rounded-circle me-2"
                                          src="../../../../assets/img/profiles/avatar-01.jpg"
                                          alt="Img"
                                        />
                                        Andrew Symon
                                      </a>
                                    </div>
                                  </div>
                                  <div class="col-md-1">
                                    <div class="dropdown ms-2">
                                      <a
                                        href="javascript:void(0);"
                                        class="d-inline-flex align-items-center"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                      >
                                        <i class="ti ti-dots-vertical"></i>
                                      </a>
                                      <ul class="dropdown-menu dropdown-menu-end p-3">
                                        <li>
                                          <a
                                            href="javascript:void(0);"
                                            class="dropdown-item rounded-1"
                                            data-bs-toggle="modal"
                                            data-bs-target="#asset_info"
                                            >View Info</a
                                          >
                                        </li>
                                        <li>
                                          <a
                                            href="javascript:void(0);"
                                            class="dropdown-item rounded-1"
                                            data-bs-toggle="modal"
                                            data-bs-target="#refuse_msg"
                                            >Raise Issue
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="tab-pane fade"
                        id="salary"
                        role="tabpanel"
                        aria-labelledby="address-tab2"
                        tabindex="0"
                      >
                        <!-- <ng-container
                          *ngIf="(employee$ | async)?.role === 'Contractor'; else employeeSalaryTab"
                        > -->
                        <ng-container *ngIf="employee$ | async as employee">
                          <ng-container *ngIf="isContractor(employee); else employeeSalaryTab">
                            <div class="row">
                              <div class="d-flex justify-content-end">
                                <button
                                  *ngIf="(payout$ | async) === null"
                                  [routerLink]="[eps.hrm.createPayoutPath, employeeId]"
                                  class="btn btn-primary d-flex align-items-center"
                                >
                                  <i class="ti ti-circle-plus me-2"></i>Add Payout
                                </button>
                                <app-payout-tab [employeeId]="employee.id"></app-payout-tab>
                              </div>
                            </div>
                          </ng-container>
                        </ng-container>
                        <ng-template #employeeSalaryTab>
                          <div class="row">
                            <div class="d-flex justify-content-end">
                              <!-- <ng-container *ngIf="(employee$ | async)?.role === 'Contractor'; else employeeSalary"> -->
                              <ng-container *ngIf="employee$ | async as employee">
                                <ng-container *ngIf="isContractor(employee); else employeeSalary">
                                  <button
                                    *ngIf="(payout$ | async) === null"
                                    [routerLink]="[eps.hrm.createPayoutPath, employeeId]"
                                    class="btn btn-primary d-flex align-items-center"
                                  >
                                    <i class="ti ti-circle-plus me-2"></i>Add Payout
                                  </button>
                                </ng-container>
                              </ng-container>
                              <ng-template #employeeSalary>
                                <button
                                  *ngIf="
                                    employeeSalaryDetails === undefined ||
                                    employeeSalaryDetails === null ||
                                    employeeSalaryDetails.ctc.ctc === 0
                                  "
                                  [routerLink]="[eps.hrm.createSalaryPath, employeeId]"
                                  class="btn btn-primary d-flex align-items-center"
                                >
                                  <i class="ti ti-circle-plus me-2"></i>Add
                                  {{ isContractor(employee) ? 'Payout' : 'Salary' }}
                                </button>
                              </ng-template>
                            </div>
                            <ng-template
                              [appHasPermission]="[{ employeeSalary: ['edit'] }]"
                              #salaryEditPermission="hasPermission"
                            >
                            </ng-template>
                            <div
                              [class.col-xl-8]="salaryEditPermission.hasAccess"
                              [class.col-xl-12]="!salaryEditPermission.hasAccess"
                            >
                              <div
                                *ngIf="
                                  (employeeSalaryDetails?.ctcValue ?? 0) > 0 &&
                                  employeeSalaryDetails !== null
                                "
                              >
                                <div class="d-flex justify-content-between">
                                  <p>Effective From</p>
                                  <p>
                                    {{ employeeSalaryDetails.effectiveFrom | date: 'MMM dd, yyyy' }}
                                  </p>
                                </div>
                                <div class="d-flex justify-content-between">
                                  <p>Compliances</p>
                                  <div>
                                    <ng-container *ngIf="hasValidCompliances(); else noCompliance">
                                      <ng-container
                                        *ngFor="let compliance of salaryCompliancesList | keyvalue"
                                      >
                                        <span
                                          class="badge bg-soft-info me-1"
                                          *ngIf="
                                            compliance.key !== 'employerCapping' &&
                                            compliance.value === true
                                          "
                                        >
                                          {{ compliance.key + '' | uppercase }}
                                        </span>
                                      </ng-container>
                                    </ng-container>

                                    <ng-template #noCompliance>
                                      <span>None</span>
                                    </ng-template>
                                  </div>
                                </div>
                                <div class="d-flex justify-content-between">
                                  <p>Total Annual CTC</p>
                                  <p>
                                    {{
                                      employeeSalaryDetails !== undefined &&
                                      employeeSalaryDetails !== null
                                        ? (employeeSalaryDetails.ctcValue
                                          | currency
                                            : employeeSalaryDetails.ctc.currency
                                            : 'symbol'
                                            : '1.0-0'
                                            : 'en-IN')
                                        : ''
                                    }}
                                  </p>
                                </div>
                                <div class="d-flex justify-content-between">
                                  <p>Currency</p>
                                  <p>{{ employeeSalaryDetails.ctc.currency }}</p>
                                </div>
                                <!--Salary Summary-->
                                <table class="table datatable">
                                  <thead class="thead-light">
                                    <tr>
                                      <th>Salary Component</th>
                                      <th>Type</th>
                                      <th>Amount</th>
                                      <th>Monthly</th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    <!-- ================= EARNINGS ================= -->
                                    <tr class="table-primary">
                                      <td colspan="4" class="fw-bold text-uppercase">Earnings</td>
                                    </tr>

                                    <!-- Standard Earnings -->
                                    <tr *ngFor="let item of salaryDataArr">
                                      <ng-container
                                        *ngIf="item[0] !== 'otherComponents' && item[1] > 0"
                                      >
                                        <td style="word-wrap: break-word; white-space: normal">
                                          {{ item[0] }}
                                        </td>
                                        <td>
                                          <span class="badge bg-soft-success">Earning</span>
                                        </td>
                                        <td>
                                          {{
                                            item[1]
                                              | currency
                                                : employeeSalaryDetails.ctc.currency
                                                : 'symbol'
                                                : '1.0-0'
                                                : 'en-IN'
                                          }}
                                        </td>
                                        <!-- Monthly -->
                                        <td>
                                          {{
                                            (item[0] === 'Special Allowance'
                                              ? Math.trunc(item[1] / 12)
                                              : item[1] / 12
                                            )
                                              | currency
                                                : employeeSalaryDetails.ctc.currency
                                                : 'symbol'
                                                : '1.0-0'
                                                : 'en-IN'
                                          }}
                                        </td>
                                      </ng-container>
                                    </tr>

                                    <!-- Other Earning Components -->
                                    <!-- <ng-container
                                      *ngFor="
                                        let item of employeeSalaryDetails?.salaryData
                                          ?.otherComponents
                                      "
                                    >
                                      <tr *ngIf="item.componentType !== 'customDeductions'">
                                        <td style="word-wrap: break-word; white-space: normal">
                                          {{ item.name }}
                                        </td>
                                        <td>
                                          <span class="badge bg-soft-success">Earning</span>
                                        </td>
                                        <td>
                                          {{
                                            item.employerContribution
                                              | currency
                                                : employeeSalaryDetails.ctc.currency
                                                : 'symbol'
                                                : '1.0-0'
                                                : 'en-IN'
                                          }}
                                        </td>
                                        <td>
                                          {{
                                            (item.employerContribution ?? 0) / 12
                                              | currency
                                                : employeeSalaryDetails.ctc.currency
                                                : 'symbol'
                                                : '1.0-0'
                                                : 'en-IN'
                                          }}
                                        </td>
                                      </tr>
                                    </ng-container> -->
                                    <tr class="table-light fw-bold">
                                      <td>Total Earnings</td>
                                      <td></td>
                                      <td>
                                        {{
                                          totalEarnings
                                            | currency
                                              : employeeSalaryDetails.ctc.currency
                                              : 'symbol'
                                              : '1.0-0'
                                              : 'en-IN'
                                        }}
                                      </td>
                                      <td>
                                        {{
                                          Math.floor(totalEarnings / 12)
                                            | currency
                                              : employeeSalaryDetails.ctc.currency
                                              : 'symbol'
                                              : '1.0-0'
                                              : 'en-IN'
                                        }}
                                      </td>
                                    </tr>
                                    <!-- ================= DEDUCTIONS ================= -->
                                    <tr class="table-danger">
                                      <td colspan="4" class="fw-bold text-uppercase">Deductions</td>
                                    </tr>

                                    <ng-container
                                      *ngFor="
                                        let item of employeeSalaryDetails?.salaryData
                                          ?.otherComponents
                                      "
                                    >
                                      <ng-container
                                        *ngIf="item.componentType === 'customDeductions'"
                                      >
                                        <!-- Employer Contribution -->
                                        <tr>
                                          <td style="word-wrap: break-word; white-space: normal">
                                            {{ item.name }} - Employer Contribution
                                          </td>
                                          <td>
                                            <span class="badge bg-soft-danger">Deduction</span>
                                          </td>
                                          <td>
                                            {{
                                              item.employerContribution
                                                | currency
                                                  : employeeSalaryDetails.ctc.currency
                                                  : 'symbol'
                                                  : '1.0-0'
                                                  : 'en-IN'
                                            }}
                                          </td>
                                          <!-- Monthly -->
                                          <td>
                                            {{
                                              (item.employerContribution ?? 0) / 12
                                                | currency
                                                  : employeeSalaryDetails.ctc.currency
                                                  : 'symbol'
                                                  : '1.0-0'
                                                  : 'en-IN'
                                            }}
                                          </td>
                                        </tr>

                                        <!-- Employee Contribution -->
                                        <tr>
                                          <td style="word-wrap: break-word; white-space: normal">
                                            {{ item.name }} - Employee Contribution
                                          </td>
                                          <td>
                                            <span class="badge bg-soft-danger">Deduction</span>
                                          </td>
                                          <td>
                                            {{
                                              item.employeeContribution
                                                | currency
                                                  : employeeSalaryDetails.ctc.currency
                                                  : 'symbol'
                                                  : '1.0-0'
                                                  : 'en-IN'
                                            }}
                                          </td>
                                          <!-- Monthly -->
                                          <td>
                                            {{
                                              (item.employeeContribution ?? 0) / 12
                                                | currency
                                                  : employeeSalaryDetails.ctc.currency
                                                  : 'symbol'
                                                  : '1.0-0'
                                                  : 'en-IN'
                                            }}
                                          </td>
                                        </tr>
                                      </ng-container>
                                    </ng-container>
                                    <tr class="table-light fw-bold">
                                      <td>Total Deductions</td>
                                      <td></td>
                                      <td>
                                        {{
                                          totalDeductions
                                            | currency
                                              : employeeSalaryDetails.ctc.currency
                                              : 'symbol'
                                              : '1.0-0'
                                              : 'en-IN'
                                        }}
                                      </td>
                                      <td>
                                        {{
                                          totalDeductions / 12
                                            | currency
                                              : employeeSalaryDetails.ctc.currency
                                              : 'symbol'
                                              : '1.0-0'
                                              : 'en-IN'
                                        }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                            <div
                              class="col-xl-4"
                              *appHasPermission="[{ employeeSalary: ['edit'] }]"
                            >
                              <div
                                class="card"
                                *ngIf="
                                  (employeeSalaryDetails?.ctcValue ?? 0) > 0 &&
                                  employeeSalaryDetails !== null
                                "
                              >
                                <div class="card-body">
                                  <!-- <div class="d-flex flex-column list-group settings-list"> -->
                                  <div class="d-flex flex-column gap-3">
                                    <button
                                      (click)="openBusinessModal(previewMonthlySalary)"
                                      class="btn btn-primary"
                                      type="button"
                                      *appHasPermission="[{ employeeSalary: ['view'] }]"
                                    >
                                      Preview Monthly Salary
                                    </button>
                                    <button
                                      [routerLink]="[eps.hrm.reviseSalaryPath, employeeId]"
                                      class="btn btn-primary"
                                      type="button"
                                      *appHasPermission="[
                                        { employeeSalary: ['edit'], salaryRevision: ['view'] }
                                      ]"
                                    >
                                      Revise Salary
                                    </button>
                                    <button
                                      [routerLink]="[eps.hrm.updateSalaryPath, employeeId]"
                                      class="btn btn-primary"
                                      type="button"
                                      *appHasPermission="[{ employeeSalary: ['edit'] }]"
                                    >
                                      Update Salary
                                    </button>
                                    <button
                                      (click)="
                                        openBusinessModal(viewAllSalaries, {
                                          modalType: 'viewAllSalaries'
                                        })
                                      "
                                      class="btn btn-primary"
                                      type="button"
                                      *appHasPermission="[{ employeeSalary: ['view'] }]"
                                    >
                                      View All Salaries
                                    </button>
                                    <button
                                      [routerLink]="[eps.hrm.payrollSummaryPath, employeeId]"
                                      class="btn btn-primary"
                                      type="button"
                                      *appHasPermission="[
                                        { payroll: ['view'], salaryRevision: ['view'] }
                                      ]"
                                    >
                                      Payroll History
                                    </button>
                                  </div>
                                  <!-- </div> -->
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                      </div>
                      <div
                        class="tab-pane fade"
                        id="basic-info-tasklogs"
                        role="tabpanel"
                        aria-labelledby="info-tab-tasklogs"
                        tabindex="0"
                      >
                        <div class="row">
                          <ng-container *ngIf="tasklogs$ | async as tasklogs">
                            <div class="col-md-12 d-flex">
                              <div class="card flex-fill">
                                <div class="card-body p-0">
                                  <div class="custom-datatable-filter table-responsive">
                                    <ng-container *ngIf="tasklogs">
                                      <table
                                        class="table datatable"
                                        *ngIf="tasklogs.length > 0; else noTasklogRecords"
                                      >
                                        <thead class="thead-light">
                                          <tr>
                                            <th>Action</th>
                                            <th>Date Time</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <ng-container *ngIf="employee$ | async as currentUser">
                                            <tr *ngFor="let tasklog of tasklogs">
                                              <!--<td>
                                              <span
                                                *ngIf="tasklog.status === 'Success'"
                                                class="badge badge-success d-inline-flex align-items-center badge-xs"
                                              >
                                                <i class="ti ti-point-filled me-1"></i
                                                >{{ tasklog.status }}
                                              </span>
                                              <span
                                                *ngIf="tasklog.status === 'Error'"
                                                class="badge badge-danger d-inline-flex align-items-center badge-xs"
                                              >
                                                <i class="ti ti-point-filled me-1"></i
                                                >{{ tasklog.status }}
                                              </span>
                                            </td>-->
                                              <td>
                                                <span class="text-wrap d-inline-block">
                                                  <ng-container
                                                    *ngFor="
                                                      let segment of tasklog
                                                        | generateLogMessage: currentUser
                                                    "
                                                  >
                                                    <a
                                                      class="text-primary"
                                                      *ngIf="segment.link"
                                                      [routerLink]="segment.link"
                                                      >{{ segment.text }}</a
                                                    >
                                                    <!-- If the segment has NO link, render plain text -->
                                                    <ng-container *ngIf="!segment.link">{{
                                                      segment.text
                                                    }}</ng-container>
                                                  </ng-container>
                                                </span>
                                              </td>
                                              <td>
                                                {{ tasklog.createdAt | date: 'medium' }}
                                              </td>
                                            </tr>
                                          </ng-container>
                                        </tbody>
                                      </table>
                                    </ng-container>
                                    <ng-template #noTasklogRecords>
                                      <div class="mb-3">
                                        <div
                                          class="d-flex align-items-center justify-content-between"
                                        >
                                          Record not available.
                                        </div>
                                      </div>
                                    </ng-template>
                                  </div>
                                </div>
                                <!-- pagination -->
                                <ng-container *ngIf="tasklogs$ | async as tasklog">
                                  <div
                                    class="d-flex align-items-center justify-content-between ms-2"
                                    *ngIf="tasklog.length > 0 && totalTasklogCount > 0"
                                  >
                                    <div>
                                      Showing
                                      {{ ((currentTasklogPage || 1) - 1) * (pageLimit || 10) + 1 }}
                                      to
                                      {{ pageTasklogLastRecord }} of {{ totalTasklogCount }} entries
                                    </div>
                                    <div class="has-text-centered mt-3">
                                      <app-pagination
                                        [currentPage]="currentTasklogPage"
                                        [pageSize]="pageLimit"
                                        [totalRows]="totalTasklogCount"
                                        (pageChange)="onTasklogPageChange($event)"
                                      ></app-pagination>
                                    </div>
                                  </div>
                                </ng-container>
                              </div>
                            </div>
                          </ng-container>

                          <!-- permission set -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<!-- /Page Wrapper -->

<!-- Edit Personal -->
<ng-template #personalModal let-modal>
  <!-- <div class="modal fade" id="edit_personal">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content"> -->
  <div class="modal-header">
    <h4 class="modal-title">Edit Personal Info</h4>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <form [formGroup]="personalform" autocomplete="off">
    <div class="modal-body pb-0">
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label" for="passport">Passport No </label>
            <input type="text" class="form-control" formControlName="passport" appTrimInput />
            <div
              *ngIf="personalform.get('passport')?.invalid && personalform.get('passport')?.touched"
            >
              <span class="text-danger">
                {{ getErrorMessage('passport') }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label" for="passportExpiryDate">Passport Expiry Date </label>
            <div class="input-icon-end position-relative">
              <input
                type="date"
                class="form-control"
                placeholder="dd/mm/yyyy"
                formControlName="passportExpiryDate"
                appTrimInput
              />
              <!-- <span class="input-icon-addon">
                        <i class="ti ti-calendar text-gray-7"></i>
                      </span> -->
            </div>
            <div
              *ngIf="
                personalform.get('passportExpiryDate')?.invalid &&
                personalform.get('passportExpiryDate')?.touched
              "
            >
              <span class="text-danger">
                {{ getErrorMessage('passportExpiryDate') }}
              </span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label" for="aadharNo"
              >Aadhar No. <span class="text-danger"> *</span></label
            >
            <input
              type="text"
              class="form-control"
              formControlName="aadharNo"
              appTrimInput
              maxlength="19"
              (input)="formatAadharNo($event)"
            />
            <div
              *ngIf="personalform.get('aadharNo')?.invalid && personalform.get('aadharNo')?.touched"
            >
              <span class="text-danger">
                {{ getErrorMessage('aadharNo') }}
              </span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label" for="PAN">PAN <span class="text-danger"> *</span></label>
            <input type="text" class="form-control" formControlName="PAN" appTrimInput />
            <div *ngIf="personalform.get('PAN')?.invalid && personalform.get('PAN')?.touched">
              <span class="text-danger">
                {{ getErrorMessage('PAN') }}
              </span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label" for="pfUAN">PF UAN </label>
            <input
              type="text"
              class="form-control"
              formControlName="pfUAN"
              appTrimInput
              min="0"
              maxlength="14"
            />
            <div *ngIf="personalform.get('pfUAN')?.invalid && personalform.get('pfUAN')?.touched">
              <span class="text-danger">
                {{ getErrorMessage('pfUAN') }}
              </span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label" for="esiNumber">ESI Number </label>
            <input
              type="text"
              class="form-control"
              formControlName="esiNumber"
              appTrimInput
              min="0"
              maxlength="25"
            />
            <div
              *ngIf="
                personalform.get('esiNumber')?.invalid && personalform.get('esiNumber')?.touched
              "
            >
              <span class="text-danger">
                {{ getErrorMessage('esiNumber') }}
              </span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label" for="nationality"
              >Nationality <span class="text-danger"> *</span></label
            >
            <!-- <input type="text" class="form-control" formControlName="nationality" /> -->
            <select class="form-select" formControlName="nationality">
              <option selected value="" disabled>Select Nationality</option>
              <option *ngFor="let country of countries$ | async" [value]="country.nationality">
                {{ country.nationality }}
              </option>
              <!-- <option>US</option> -->
            </select>
            <div
              *ngIf="
                personalform.get('nationality')?.invalid && personalform.get('nationality')?.touched
              "
            >
              <span class="text-danger">
                {{ getErrorMessage('nationality') }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label" for="religion"
              >Religion <span class="text-danger"> *</span></label
            >
            <select class="form-select" formControlName="religion">
              <option selected value="">Select Religion</option>
              <option [value]="religionEnum.HINDUISM">{{ religionEnum.HINDUISM }}</option>
              <option [value]="religionEnum.BUDDHISM">{{ religionEnum.BUDDHISM }}</option>
              <option [value]="religionEnum.JAINISM">
                {{ religionEnum.JAINISM }}
              </option>
              <option [value]="religionEnum.SIKHISM">
                {{ religionEnum.SIKHISM }}
              </option>
              <option [value]="religionEnum.CHRISTIANITY">{{ religionEnum.CHRISTIANITY }}</option>
              <option [value]="religionEnum.ISLAM">{{ religionEnum.ISLAM }}</option>

              <option [value]="religionEnum.OTHER">{{ religionEnum.OTHER }}</option>
            </select>
            <div
              *ngIf="personalform.get('religion')?.invalid && personalform.get('religion')?.touched"
            >
              <span class="text-danger">
                {{ getErrorMessage('religion') }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label" for="maritalStatus"
              >Marital Status <span class="text-danger"> *</span></label
            >
            <select class="form-select" formControlName="maritalStatus">
              <option selected value="">Select Marital Status</option>
              <option [value]="maritalStatusEnum.SINGLE">{{ maritalStatusEnum.SINGLE }}</option>
              <option [value]="maritalStatusEnum.MARRIED">{{ maritalStatusEnum.MARRIED }}</option>
              <option [value]="maritalStatusEnum.DIVORCED">
                {{ maritalStatusEnum.DIVORCED }}
              </option>
              <option [value]="maritalStatusEnum.SEPARAETED">
                {{ maritalStatusEnum.SEPARAETED }}
              </option>
              <option [value]="maritalStatusEnum.WIDOWED">{{ maritalStatusEnum.WIDOWED }}</option>
            </select>
            <div
              *ngIf="
                personalform.get('maritalSatus')?.invalid &&
                personalform.get('maritalSatus')?.touched
              "
            >
              <span class="text-danger">
                {{ getErrorMessage('maritalSatus') }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label" for="isSpouseEmployed"
              >Employment of spouse <span class="text-danger"> *</span></label
            >
            <select class="form-select" formControlName="isSpouseEmployed">
              <option selected [ngValue]="null">Select Spouse's Employment</option>
              <option [ngValue]="true">Yes</option>
              <option [ngValue]="false">No</option>
            </select>
            <div
              *ngIf="
                personalform.get('isSpouseEmployed')?.invalid &&
                personalform.get('isSpouseEmployed')?.touched
              "
            >
              <span class="text-danger">
                {{ getErrorMessage('isSpouseEmployed') }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label" for="noOfChildren">No. of Children </label>
            <input
              type="number"
              class="form-control"
              formControlName="noOfChildren"
              appTrimInput
              min="0"
            />
            <div
              *ngIf="
                personalform.get('noOfChildren')?.invalid &&
                personalform.get('noOfChildren')?.touched
              "
            >
              <span class="text-danger">
                {{ getErrorMessage('noOfChildren') }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-white border me-2"
        data-bs-dismiss="modal"
        (click)="onClose()"
      >
        Cancel
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        (click)="onFamilySubmit()"
        [disabled]="!personalform.valid"
      >
        Save
      </button>
    </div>
  </form>
  <!-- </div>
      </div>
    </div> -->
</ng-template>
<!-- /Edit Personal -->

<!-- add family -->
<ng-template #FamilyMemberModal let-modal>
  <!-- <div class="modal fade" id="add_familyinformation">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content"> -->
  <div class="modal-header">
    <h4 class="modal-title">Family Information</h4>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <form [formGroup]="familyform">
    <div class="modal-body pb-0">
      <div class="row">
        <div class="col-md-12">
          <div class="mb-3">
            <label class="form-label" for="name">Name <span class="text-danger"> *</span></label>
            <input type="text" class="form-control" formControlName="name" appTrimInput />
            <div *ngIf="familyform.get('name')?.invalid && familyform.get('name')?.touched">
              <span class="text-danger">
                {{ getErrorMessage('name') }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="mb-3">
            <label class="form-label" for="relation">Relationship </label>
            <!-- <input type="text" class="form-control" formControlName="relation" /> -->
            <select class="form-select" formControlName="relation">
              <option selected value="">Select Relation</option>
              <option [value]="relationEnum.FATHER">{{ relationEnum.FATHER }}</option>
              <option [value]="relationEnum.MOTHER">{{ relationEnum.MOTHER }}</option>
              <option [value]="relationEnum.SPOUSE">
                {{ relationEnum.SPOUSE }}
              </option>
              <option [value]="relationEnum.SIBLING">
                {{ relationEnum.SIBLING }}
              </option>
              <option [value]="relationEnum.SON">{{ relationEnum.SON }}</option>
              <option [value]="relationEnum.DAUGHTER">{{ relationEnum.DAUGHTER }}</option>

              <option [value]="relationEnum.OTHER">{{ relationEnum.OTHER }}</option>
            </select>
            <div *ngIf="familyform.get('relation')?.invalid && familyform.get('relation')?.touched">
              <span class="text-danger">
                {{ getErrorMessage('relation') }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="mb-3">
            <label class="form-label" for="mobile"
              >Mobile
              <i
                class="ti ti-help text-info ms-2"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Format: +91 9876543210"
              ></i
            ></label>
            <input type="text" class="form-control" formControlName="mobile" appTrimInput />
            <!-- <div *ngIf="familyform.get('mobile')?.invalid && familyform.get('mobile')?.touched">
              <span class="text-danger">
                {{ getErrorMessage('mobile') }}
              </span>
            </div> -->
            <div *ngIf="familyform.get('mobile')?.invalid && familyform.get('mobile')?.touched">
              <span class="text-danger">
                <ng-container
                  *ngIf="
                    familyform?.get('mobile')?.hasError('invalidMobileNumber') &&
                    familyform?.get('mobile')?.value !== ''
                  "
                >
                  Invalid mobile number format. Please use +XX XXXXXXXXXX.
                </ng-container>
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="mb-3">
            <label class="form-label" for="birthdate">Date of Birth </label>
            <div class="input-icon-end position-relative">
              <input
                class="form-control"
                type="date"
                formControlName="birthdate"
                appTrimInput
                max="{{ today | date: 'yyyy-MM-dd' }}"
              />
              <!-- <span class="input-icon-addon">
                    <i class="ti ti-calendar text-gray-7"></i>
                  </span> -->
            </div>
            <div
              *ngIf="familyform.get('birthdate')?.invalid && familyform.get('birthdate')?.touched"
            >
              <span class="text-danger">
                {{ getErrorMessage('birthdate') }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-white border me-2"
        data-bs-dismiss="modal"
        (click)="onClose()"
      >
        Cancel
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        (click)="addFamilyMember()"
        [disabled]="!familyform.valid"
      >
        Save
      </button>
    </div>
  </form>
  <!-- </div>
  </div>
</div> -->
</ng-template>
<!-- /edit family -->

<!-- Edit Bank -->
<ng-template #BankModal let-modal>
  <!-- <div class="modal fade" id="edit_bank">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content"> -->
  <div class="modal-header">
    <h4 class="modal-title">Bank Details</h4>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <form [formGroup]="bankForm">
    <div class="modal-body pb-0">
      <div class="row">
        <div class="col-md-12">
          <div class="mb-3">
            <label class="form-label" for="bank">Bank <span class="text-danger"> *</span></label>
            <input type="text" class="form-control" formControlName="bank" appTrimInput />
            <div *ngIf="bankForm.get('bank')?.invalid && bankForm.get('bank')?.touched">
              <span class="text-danger">
                {{ getErrorMessage('bank', bankForm) }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="mb-3">
            <label class="form-label" for="accountNo"
              >Bank Account No <span class="text-danger"> *</span></label
            >
            <input type="text" class="form-control" formControlName="accountNo" appTrimInput />
            <div *ngIf="bankForm.get('accountNo')?.invalid && bankForm.get('accountNo')?.touched">
              <span class="text-danger">
                {{ getErrorMessage('accountNo', bankForm) }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="mb-3">
            <label class="form-label" for="ifsc"
              >IFSC Code <span class="text-danger"> *</span></label
            >
            <input type="text" class="form-control" formControlName="ifsc" appTrimInput />
            <div *ngIf="bankForm.get('ifsc')?.invalid && bankForm.get('ifsc')?.touched">
              <span class="text-danger">
                {{ getErrorMessage('ifsc', bankForm) }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="mb-3">
            <label class="form-label" for="branch"
              >Branch <span class="text-danger"> *</span></label
            >
            <input type="text" class="form-control" formControlName="branch" appTrimInput />
            <div *ngIf="bankForm.get('branch')?.invalid && bankForm.get('branch')?.touched">
              <span class="text-danger">
                {{ getErrorMessage('branch', bankForm) }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-white border me-2"
        data-bs-dismiss="modal"
        (click)="onClose()"
      >
        Cancel
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        (click)="addBank()"
        [disabled]="bankloading || !bankForm.valid"
      >
        <span
          *ngIf="bankloading"
          class="spinner-border spinner-border-sm me-2"
          role="status"
          aria-hidden="true"
        ></span>
        {{ bankloading ? 'Saving...' : 'Save' }}
      </button>
    </div>
  </form>
  <!-- </div>
  </div>
</div> -->
</ng-template>
<!-- /Edit Bank -->

<!-- Add Education -->
<ng-template #addEducationModal let-modal>
  <!-- <div class="modal fade" id="edit_education">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content"> -->
  <div class="modal-header">
    <h4 class="modal-title">Education Information</h4>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <form [formGroup]="educationForm">
    <div class="modal-body pb-0">
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label" for="university"
              >Institution Name <span class="text-danger"> *</span></label
            >
            <input type="text" class="form-control" formControlName="university" appTrimInput />
            <div
              *ngIf="
                educationForm.get('university')?.invalid && educationForm.get('university')?.touched
              "
            >
              <span class="text-danger">
                {{ getErrorMessage('university') }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label">Course <span class="text-danger"> *</span></label>
            <input type="text" class="form-control" formControlName="degree" appTrimInput />
            <div
              *ngIf="educationForm.get('degree')?.invalid && educationForm.get('degree')?.touched"
            >
              <span class="text-danger">
                {{ getErrorMessage('degree') }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label" for="startDate"
              >Start Year <span class="text-danger"> *</span></label
            >
            <div class="input-icon-end position-relative">
              <!-- <input
                type="month"
                class="form-control"
                placeholder="dd/mm/yyyy"
                formControlName="startDate"
              />
              <span class="input-icon-addon">
                    <i class="ti ti-calendar text-gray-7"></i>
                  </span> -->
              <select
                class="form-control"
                formControlName="startDate"
                (change)="onYearChange($event)"
              >
                <option *ngFor="let year of years" [value]="year">{{ year }}</option>
              </select>
            </div>
            <div
              *ngIf="
                educationForm.get('startDate')?.invalid && educationForm.get('startDate')?.touched
              "
            >
              <span class="text-danger">
                {{ getErrorMessage('startDate') }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label" for="endDate"
              >End Year <span class="text-danger"> *</span></label
            >
            <div class="input-icon-end position-relative">
              <!-- <input
                type="month"
                class="form-control"
                placeholder="dd/mm/yyyy"
                formControlName="endDate"
                max="{{ today | date: 'yyyy-MM-dd' }}"
              /> -->
              <select
                class="form-control"
                formControlName="endDate"
                (change)="onYearChange($event)"
              >
                <option *ngFor="let year of years" [value]="year">{{ year }}</option>
              </select>
              <!-- <span class="input-icon-addon">
                    <i class="ti ti-calendar text-gray-7"></i>
                  </span> -->
            </div>
            <div
              *ngIf="educationForm.get('endDate')?.invalid && educationForm.get('endDate')?.touched"
            >
              <span class="text-danger">
                {{ getErrorMessage('endDate') }}
              </span>
            </div>
            <div *ngIf="educationForm.errors?.['endDateGreaterThanToday']">
              <span class="text-danger">End date cannot be greater than today.</span>
            </div>
            <div *ngIf="educationForm.errors?.['endDateLessThanStartDate']">
              <span class="text-danger">End date cannot be earlier than start date.</span>
            </div>

            <!-- Repeat for experienceForm as needed -->
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-white border me-2"
        data-bs-dismiss="modal"
        (click)="onClose()"
      >
        Cancel
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        (click)="addEducation()"
        [disabled]="!educationForm.valid"
      >
        Save
      </button>
    </div>
  </form>
  <!-- </div>
  </div>
</div> -->
</ng-template>
<!-- /Add Education -->

<!-- Add Experience -->
<ng-template #addExperienceModal let-modal>
  <!-- <div class="modal fade" id="edit_experience">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content"> -->
  <div class="modal-header">
    <h4 class="modal-title">Company Information</h4>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <form [formGroup]="experienceForm">
    <div class="modal-body pb-0">
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label" for="company"
              >Previous Company Name <span class="text-danger"> *</span></label
            >
            <input type="text" class="form-control" formControlName="company" appTrimInput />
            <div
              *ngIf="
                experienceForm.get('company')?.invalid && experienceForm.get('company')?.touched
              "
            >
              <span class="text-danger">
                {{ getErrorMessage('company') }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label" for="designation"
              >Designation <span class="text-danger"> *</span></label
            >
            <input type="text" class="form-control" formControlName="designation" appTrimInput />
            <div
              *ngIf="
                experienceForm.get('designation')?.invalid &&
                experienceForm.get('designation')?.touched
              "
            >
              <span class="text-danger">
                {{ getErrorMessage('designation') }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label" for="startDate"
              >Start Date <span class="text-danger"> *</span></label
            >
            <div class="input-icon-end position-relative">
              <input
                type="date"
                class="form-control"
                placeholder="dd/mm/yyyy"
                formControlName="startDate"
                max="{{ today | date: 'yyyy-MM-dd' }}"
              />
              <!-- <span class="input-icon-addon">
                    <i class="ti ti-calendar text-gray-7"></i>
                  </span> -->
            </div>
            <div
              *ngIf="
                experienceForm.get('startDate')?.invalid && experienceForm.get('startDate')?.touched
              "
            >
              <span class="text-danger">
                {{ getErrorMessage('startDate') }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label" for="endDate"
              >End Date <span class="text-danger"> *</span></label
            >
            <div class="input-icon-end position-relative">
              <!-- This is a single-line comment -->
              <input
                type="date"
                class="form-control"
                placeholder="dd/mm/yyyy"
                formControlName="endDate"
                [disabled]="experienceForm.get('isPresent')?.value"
                [min]="experienceForm.get('startDate')?.value"
                max="{{ today | date: 'yyyy-MM-dd' }}"
              />
              <!-- <span class="input-icon-addon">
                    <i class="ti ti-calendar text-gray-7"></i>
                  </span> -->
            </div>
            <div
              *ngIf="
                experienceForm.get('endDate')?.invalid &&
                experienceForm.get('endDate')?.touched &&
                !experienceForm.get('isPresent')?.value
              "
            >
              <span class="text-danger">
                {{ getErrorMessage('endDate') }}
              </span>
            </div>
            <div
              *ngIf="
                !experienceForm.get('isPresent')?.value &&
                experienceForm.errors?.['endDateGreaterThanToday']
              "
            >
              <span class="text-danger"> End date cannot be greater than today.</span>
            </div>
            <div
              *ngIf="
                !experienceForm.get('isPresent')?.value &&
                experienceForm.errors?.['endDateLessThanStartDate']
              "
            >
              <span class="text-danger">End date cannot be earlier than start date.</span>
            </div>

            <!-- Repeat for experienceForm as needed -->
          </div>
        </div>
        <div class="col-md-12">
          <div class="mb-3">
            <label class="form-check-label d-flex align-items-center mt-0">
              <input
                class="form-check-input mt-0 me-2"
                type="checkbox"
                formControlName="isPresent"
              />
              <span class="text-dark">Check if you working present</span>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-white border me-2"
        data-bs-dismiss="modal"
        (click)="onClose()"
      >
        Cancel
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        (click)="addExperience()"
        [disabled]="!experienceForm.valid"
      >
        Save
      </button>
    </div>
  </form>
  <!-- </div>
  </div>
</div> -->
</ng-template>
<!-- /Add Experience -->

<!-- Edit Emergency Contact -->
<ng-template #EmergencyContactModal let-modal>
  <!-- <div class="modal fade" id="edit_emergency">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content"> -->
  <div class="modal-header">
    <h4 class="modal-title">Emergency Contact Details</h4>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <form [formGroup]="emergencyContactform">
    <div class="modal-body pb-0">
      <div class="border-bottom mb-3">
        <div class="row">
          <h5 class="mb-3">Primary Contact Details</h5>
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label">Name <span class="text-danger"> *</span></label>
              <input type="text" class="form-control" formControlName="nameP" appTrimInput />
              <div
                *ngIf="
                  emergencyContactform.get('nameP')?.invalid &&
                  emergencyContactform.get('nameP')?.touched
                "
              >
                <span class="text-danger">
                  {{ getErrorMessage('nameP') }}
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label">Relationship <span class="text-danger"> *</span> </label>
              <!-- <input type="text" class="form-control" formControlName="relationshipP" /> -->
              <select class="form-select" formControlName="relationshipP">
                <option selected value="">Select Relation</option>
                <option [value]="relationEnum.FATHER">{{ relationEnum.FATHER }}</option>
                <option [value]="relationEnum.MOTHER">{{ relationEnum.MOTHER }}</option>
                <option [value]="relationEnum.SPOUSE">
                  {{ relationEnum.SPOUSE }}
                </option>
                <option [value]="relationEnum.SIBLING">
                  {{ relationEnum.SIBLING }}
                </option>
                <option [value]="relationEnum.SON">{{ relationEnum.SON }}</option>
                <option [value]="relationEnum.DAUGHTER">{{ relationEnum.DAUGHTER }}</option>

                <option [value]="relationEnum.OTHER">{{ relationEnum.OTHER }}</option>
              </select>
              <div
                *ngIf="
                  emergencyContactform.get('relationshipP')?.invalid &&
                  emergencyContactform.get('relationshipP')?.touched
                "
              >
                <span class="text-danger">
                  {{ getErrorMessage('relationshipP') }}
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label"
                >Primary Mobile No <span class="text-danger"> *</span></label
              >
              <input type="text" class="form-control" formControlName="phoneP" appTrimInput />
              <div
                *ngIf="
                  emergencyContactform.get('phoneP')?.invalid &&
                  emergencyContactform.get('phoneP')?.touched
                "
              >
                <span class="text-danger">
                  <ng-container
                    *ngIf="
                      emergencyContactform.get('phoneP')?.hasError('required') &&
                      emergencyContactform.get('phoneP')?.value === ''
                    "
                  >
                    Mobile number is required.
                  </ng-container>
                  <ng-container
                    *ngIf="
                      emergencyContactform.get('phoneP')?.hasError('invalidPhoneNumber') &&
                      emergencyContactform.get('phoneP')?.value !== ''
                    "
                  >
                    Invalid phone number format. Please use +XX XXXXXXXXXX.
                  </ng-container>
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label">Secondary Mobile No </label>
              <input type="text" class="form-control" formControlName="phone2P" appTrimInput />
              <div
                *ngIf="
                  emergencyContactform.get('phone2P')?.invalid &&
                  emergencyContactform.get('phone2P')?.touched
                "
              >
                <span class="text-danger">
                  <ng-container
                    *ngIf="
                      emergencyContactform.get('phone2P')?.hasError('required') &&
                      emergencyContactform.get('phone2P')?.value === ''
                    "
                  >
                    Mobile number is required.
                  </ng-container>
                  <ng-container
                    *ngIf="
                      emergencyContactform.get('phone2P')?.hasError('invalidPhoneNumber') &&
                      emergencyContactform.get('phone2P')?.value !== ''
                    "
                  >
                    Invalid phone number format. Please use +XX XXXXXXXXXX.
                  </ng-container>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <h5 class="mb-3">Secondary Contact Details</h5>
        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label"
              >Name
              <!-- <span class="text-danger"> *</span> -->
            </label>
            <input type="text" class="form-control" formControlName="nameS" appTrimInput />
            <div
              *ngIf="
                emergencyContactform.get('nameS')?.invalid &&
                emergencyContactform.get('nameS')?.touched
              "
            >
              <span class="text-danger">
                {{ getErrorMessage('nameS') }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label"
              >Relationship
              <!-- <span class="text-danger"> *</span> -->
            </label>
            <!-- <input type="text" class="form-control" formControlName="relationshipS" /> -->
            <select class="form-select" formControlName="relationshipS">
              <option selected value="">Select Relation</option>
              <option [value]="relationEnum.FATHER">{{ relationEnum.FATHER }}</option>
              <option [value]="relationEnum.MOTHER">{{ relationEnum.MOTHER }}</option>
              <option [value]="relationEnum.SPOUSE">
                {{ relationEnum.SPOUSE }}
              </option>
              <option [value]="relationEnum.SIBLING">
                {{ relationEnum.SIBLING }}
              </option>
              <option [value]="relationEnum.SON">{{ relationEnum.SON }}</option>
              <option [value]="relationEnum.DAUGHTER">{{ relationEnum.DAUGHTER }}</option>

              <option [value]="relationEnum.OTHER">{{ relationEnum.OTHER }}</option>
            </select>
            <div
              *ngIf="
                emergencyContactform.get('relationshipS')?.invalid &&
                emergencyContactform.get('relationshipS')?.touched
              "
            >
              <span class="text-danger">
                {{ getErrorMessage('relationshipS') }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label"
              >Primary Mobile No
              <!-- <span class="text-danger"> *</span> -->
            </label>
            <input type="text" class="form-control" formControlName="phoneS" appTrimInput />
            <div
              *ngIf="
                emergencyContactform.get('phoneS')?.invalid &&
                emergencyContactform.get('phoneS')?.touched
              "
            >
              <span class="text-danger">
                <ng-container
                  *ngIf="
                    emergencyContactform.get('phoneS')?.hasError('required') &&
                    emergencyContactform.get('phoneS')?.value === ''
                  "
                >
                  Mobile number is required.
                </ng-container>
                <ng-container
                  *ngIf="
                    emergencyContactform.get('phoneS')?.hasError('invalidPhoneNumber') &&
                    emergencyContactform.get('phoneS')?.value !== ''
                  "
                >
                  Invalid phone number format. Please use +XX XXXXXXXXXX.
                </ng-container>
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label">Secondary Mobile No</label>
            <input type="text" class="form-control" formControlName="phone2S" appTrimInput />
            <div
              *ngIf="
                emergencyContactform.get('phone2S')?.invalid &&
                emergencyContactform.get('phone2S')?.touched
              "
            >
              <span class="text-danger">
                <ng-container
                  *ngIf="
                    emergencyContactform.get('phone2S')?.hasError('required') &&
                    emergencyContactform.get('phone2S')?.value === ''
                  "
                >
                  Mobile number is required.
                </ng-container>
                <ng-container
                  *ngIf="
                    emergencyContactform.get('phone2S')?.hasError('invalidPhoneNumber') &&
                    emergencyContactform.get('phone2S')?.value !== ''
                  "
                >
                  Invalid phone number format. Please use +XX XXXXXXXXXX.
                </ng-container>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-white border me-2"
        data-bs-dismiss="modal"
        (click)="onClose()"
      >
        Cancel
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        (click)="updateEmergencyContact()"
        [disabled]="!emergencyContactform.valid"
      >
        Save
      </button>
    </div>
  </form>
  <!-- </div>
  </div>
</div> -->
</ng-template>
<!-- /Edit Emergency Contact -->

<!-- Edit Employee -->
<ng-template #addBusinessModal let-modal>
  <!-- <div class="modal custom-modal fade custom-modal-two modal-padding" id="add_company" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content"> -->
  <div class="modal-header header-border justify-content-between m-2">
    <h5 class="modal-title">Edit Employee</h5>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <div class="modal-body m-2">
    <div class="contact-grids-tab">
      <ul class="nav nav-underline" id="myTab" role="tablist">
        <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 1"
          (click)="stepChange(1)"
        >
          <!-- <span class="nav-link" [class.active]="currentStep === 1">Basic Information</span> -->
          <a href="javascript:void(0)" class="nav-link" [class.active]="currentStep === 1"
            >Basic Information</a
          >
        </li>
        <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 2"
          (click)="stepChange(2)"
        >
          <!-- <span class="nav-link" [class.active]="currentStep === 2">Company Information</span> -->
          <a href="javascript:void(0)" class="nav-link" [class.active]="currentStep === 2"
            >Company Information</a
          >
        </li>
        <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 3"
          (click)="stepChange(3)"
        >
          <!-- <span class="nav-link" [class.active]="currentStep === 3">Address</span> -->
          <a href="javascript:void(0)" class="nav-link" [class.active]="currentStep === 3"
            >Address</a
          >
        </li>
        <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 4"
          (click)="stepChange(4)"
        >
          <!-- <span class="nav-link" [class.active]="currentStep === 4">Social Profiles</span> -->
          <a href="javascript:void(0)" class="nav-link" [class.active]="currentStep === 4"
            >Social Profiles</a
          >
        </li>
        <!-- <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 5"
          (click)="stepChange(5)"
        >
          <a href="javascript:void(0)" class="nav-link" [class.active]="currentStep === 5"
            >Roles & Permissions</a
          >
        </li> -->
      </ul>
    </div>

    <div class="tab-content">
      <form [formGroup]="form" autocomplete="off" enctype="multipart/form-data">
        <!-- Step 1 (Basic Info) -->
        <fieldset *ngIf="currentStep === 1" formGroupName="basicInfoForm" id="first-field">
          <div class="col-md-12">
            <div
              class="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4"
            >
              <div
                class="d-flex align-items-center justify-content-center avatar avatar-xxl rounded-circle border border-dashed me-2 flex-shrink-0 text-dark frames"
              >
                <i class="ti ti-photo text-gray-2 fs-16" *ngIf="!imageURL"></i>
                <!-- <span><img [src]="(employee.user?.picture ? (apiEndpoint + employee.user?.picture) : defaultImg)" alt="Img" class="img-fluid rounded-circle"  ></span> -->
                <!-- <span
                  ><img
                    [src]="imageURL"
                    alt="Img"
                    class="img-fluid rounded-circle"
                    *ngIf="imageURL"
                /></span> -->
                <img
                  [src]="imageURL"
                  alt="Img"
                  *ngIf="imageURL"
                  class="rounded-circle"
                  style="width: 100%; height: 100%; object-fit: cover"
                  (error)="imageURL = defaultImg"
                />
              </div>
              <div class="profile-upload">
                <div class="mb-2">
                  <h6 class="mb-1">Upload Profile Image</h6>
                  <!-- <p class="fs-12">Image should be below 4 mb</p> -->
                </div>
                <div class="profile-uploader d-flex align-items-center">
                  <div class="drag-upload-btn btn btn-sm btn-primary me-2">
                    Upload
                    <input
                      type="file"
                      class="form-control image-sign"
                      accept="image/jpeg, image/png, image/gif, image/svg+xml, image/webp"
                      (change)="onFileChange($event, 'imageURL')"
                    />
                  </div>
                  <!-- <a href="javascript:void(0);" class="btn btn-light btn-sm">Cancel</a> -->
                </div>
              </div>
            </div>
          </div>
          <div class="contact-input-set">
            <div class="row">
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >First Name <span class="text-danger"> *</span></label
                  >
                  <input formControlName="firstName" class="form-control" appTrimInput />
                  <div
                    *ngIf="
                      form.get('basicInfoForm')?.get('firstName')?.invalid &&
                      form.get('basicInfoForm')?.get('firstName')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('basicInfoForm.firstName') }}
                    </span>
                  </div>
                  <!-- Other fields for Basic Info here -->
                </div>
              </div>

              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Last Name <span class="text-danger"> *</span></label
                  >
                  <input formControlName="lastName" class="form-control" appTrimInput />
                  <div
                    *ngIf="
                      form.get(' ')?.get('lastName')?.invalid &&
                      form.get('basicInfoForm')?.get('lastName')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('basicInfoForm.lastName') }}
                    </span>
                  </div>
                  <!-- Other fields for Basic Info here -->
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Work Email <span class="text-danger"> *</span>
                    <i
                      class="ti ti-help text-info ms-2"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Format: dave@gmail.com"
                    ></i
                  ></label>
                  <input
                    formControlName="email"
                    class="form-control"
                    type="email"
                    autocomplete="off"
                    appStrictEmail
                    appTrimInput
                  />
                  <div
                    *ngIf="
                      form.get('basicInfoForm')?.get('email')?.invalid &&
                      form.get('basicInfoForm')?.get('email')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('basicInfoForm.email') }}
                    </span>
                  </div>
                  <!-- Other fields for Basic Info here -->
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">Personal Email </label>
                  <input
                    formControlName="personalEmail"
                    class="form-control"
                    type="email"
                    autocomplete="off"
                    appTrimInput
                    appStrictEmail
                  />
                  <div
                    *ngIf="
                      form.get('basicInfoForm')?.get('personalEmail')?.invalid &&
                      form.get('basicInfoForm')?.get('personalEmail')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('basicInfoForm.personalEmail') }}
                    </span>
                  </div>
                  <!-- Other fields for Basic Info here -->
                </div>
              </div>

              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Mobile Number<span class="text-danger"> *</span>
                    <i
                      class="ti ti-help text-info ms-2"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Format: +91 9876543210"
                    ></i
                  ></label>
                  <input class="form-control" type="text" formControlName="mobile" />
                  <div
                    *ngIf="
                      form.get('basicInfoForm')?.get('mobile')?.invalid &&
                      form.get('basicInfoForm')?.get('mobile')?.touched
                    "
                  >
                    <span class="text-danger">
                      <ng-container
                        *ngIf="
                          form.get('basicInfoForm')?.get('mobile')?.hasError('required') &&
                          form.get('basicInfoForm')?.get('mobile')?.value === ''
                        "
                      >
                        Mobile number is required.
                      </ng-container>
                      <ng-container
                        *ngIf="
                          form
                            .get('basicInfoForm')
                            ?.get('mobile')
                            ?.hasError('invalidMobileNumber') &&
                          form.get('basicInfoForm')?.get('mobile')?.value !== ''
                        "
                      >
                        Invalid mobile number format. Please use +XX XXXXXXXXXX.
                      </ng-container>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">Alternate Mobile Number</label>
                  <input class="form-control" type="text" formControlName="personalMobile" />
                  <div
                    *ngIf="
                      form.get('basicInfoForm')?.get('personalMobile')?.invalid &&
                      form.get('basicInfoForm')?.get('personalMobile')?.touched
                    "
                  >
                    <span class="text-danger">
                      <ng-container
                        *ngIf="
                          form.get('basicInfoForm')?.get('personalMobile')?.hasError('required') &&
                          form.get('basicInfoForm')?.get('personalMobile')?.value === ''
                        "
                      >
                        Mobile number is required.
                      </ng-container>
                      <ng-container
                        *ngIf="
                          form
                            .get('basicInfoForm')
                            ?.get('personalMobile')
                            ?.hasError('invalidPhoneNumber') &&
                          form.get('basicInfoForm')?.get('personalMobile')?.value !== ''
                        "
                      >
                        Invalid mobile number format. Please use +XX XXXXXXXXXX.
                      </ng-container>
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">Date of Birth </label>
                  <input
                    class="form-control"
                    type="date"
                    formControlName="birthdate"
                    [max]="maxDate"
                  />
                  <div
                    *ngIf="
                      form.get('basicInfoForm')?.get('birthdate')?.invalid &&
                      form.get('basicInfoForm')?.get('birthdate')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('basicInfoForm.birthdate') }}
                    </span>
                  </div>
                  <ng-container *ngIf="form.get('basicInfoForm.birthdate')?.hasError('ageInvalid')">
                    <span class="text-danger">You must be at least 18 years old.</span>
                  </ng-container>
                </div>
              </div>

              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">Gender <span class="text-danger">*</span></label>
                  <select class="form-select" formControlName="gender">
                    <option disabled>Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Transgender">Transgender</option>
                  </select>

                  <div
                    *ngIf="
                      form.get('basicInfoForm')?.get('gender')?.invalid &&
                      form.get('basicInfoForm')?.get('gender')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('basicInfoForm.gender') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="input-block mb-3">
                  <label class="col-form-label">About </label>
                  <textarea class="form-control" type="text" formControlName="about"></textarea>
                  <div
                    *ngIf="
                      form.get('basicInfoForm')?.get('about')?.invalid &&
                      form.get('basicInfoForm')?.get('about')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('basicInfoForm.about') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-lg-12 text-end form-wizard-button">
                <button
                  type="button"
                  (click)="goToNextStep()"
                  [disabled]="!form.get('basicInfoForm')?.valid"
                  class="btn btn-primary wizard-next-btn"
                >
                  Save & Next
                </button>
              </div>
            </div>
          </div>
        </fieldset>

        <fieldset *ngIf="currentStep === 2" formGroupName="companyInfoForm">
          <div class="contact-input-set">
            <div class="row">
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Employee ID<span class="text-danger"> *</span></label
                  >
                  <input class="form-control" type="text" formControlName="empId" />
                  <div
                    *ngIf="
                      form.get('companyInfoForm')?.get('empId')?.invalid &&
                      form.get('companyInfoForm')?.get('empId')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('companyInfoForm.empId') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Date of Joining <span class="text-danger"> *</span></label
                  >
                  <input
                    class="form-control"
                    type="date"
                    formControlName="joiningDate"
                    [max]="todayplussixmonths | date: 'yyyy-MM-dd'"
                    [min]="(employee$ | async)?.business?.incorporationDate | date: 'yyyy-MM-dd'"
                  />
                  <div
                    *ngIf="
                      form.get('companyInfoForm')?.get('joiningDate')?.invalid &&
                      form.get('companyInfoForm')?.get('joiningDate')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('companyInfoForm.joiningDate') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label" for="businessId"
                    >Business Entity <span class="text-danger">*</span></label
                  >
                  <!-- <select
                    class="form-select"
                    formControlName="businessId"
                    (change)="
                      onBusinessSelect(form.get('companyInfoForm')?.get('businessId')?.value)
                    "
                  >
                    <option selected value="">Select Business Enitty</option>
                    <option *ngFor="let business of businesses$ | async" [value]="business.id">
                      {{ business.businessName | capitalize }}
                    </option>
                  </select> -->
                  <ng-select
                    class="me-3 w-100"
                    [items]="businesses$ | async"
                    bindValue="id"
                    placeholder="Select Business Entity"
                    [searchable]="true"
                    [clearable]="true"
                    [searchFn]="customSearchFn"
                    style="width: 200px"
                    formControlName="businessId"
                    (change)="
                      onBusinessSelect(form.get('companyInfoForm')?.get('businessId')?.value)
                    "
                    readonly
                  >
                    <ng-template ng-label-tmp let-item="item">
                      {{ item.businessName | capitalize }}
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                      {{ item.businessName | capitalize }}
                    </ng-template>
                  </ng-select>
                  <div
                    *ngIf="
                      form.get('companyInfoForm')?.get('businessId')?.invalid &&
                      form.get('companyInfoForm')?.get('businessId')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('companyInfoForm.businessId') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label" for="officeId"
                    >Office <span class="text-danger">*</span></label
                  >
                  <select class="form-select" formControlName="officeId">
                    <option selected value="">Select Office</option>
                    <option *ngFor="let office of offices$ | async" [value]="office.id">
                      {{ office.officeName | capitalize }}
                    </option>
                    <!-- <option>Guillory</option>
                    <option>Jami</option> -->
                  </select>
                  <div
                    *ngIf="
                      form.get('companyInfoForm')?.get('officeId')?.invalid &&
                      form.get('companyInfoForm')?.get('officeId')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('companyInfoForm.officeId') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label" for="departmentId"
                    >Department <span class="text-danger">*</span></label
                  >
                  <select
                    class="form-select"
                    formControlName="departmentId"
                    (change)="
                      onDepartmentSelect(form.get('companyInfoForm')?.get('departmentId')?.value)
                    "
                  >
                    <option selected value="">Select Department</option>
                    <option *ngFor="let department of departments$ | async" [value]="department.id">
                      {{ department.departmentName | capitalize }}
                    </option>
                    <!-- <option>IT Management</option>
                      <option> Marketing</option> -->
                  </select>
                  <div
                    *ngIf="
                      form.get('companyInfoForm')?.get('departmentId')?.invalid &&
                      form.get('companyInfoForm')?.get('departmentId')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('companyInfoForm.departmentId') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label" for="designationId"
                    >Designation <span class="text-danger">*</span></label
                  >
                  <select class="form-select" formControlName="designationId">
                    <option selected value="">Select Designation</option>
                    <option
                      *ngFor="let designation of designations$ | async"
                      [value]="designation.id"
                    >
                      {{ designation.designationName | capitalize }}
                    </option>
                    <!-- <option>IT Management</option>
                      <option> Marketing</option> -->
                  </select>
                  <div
                    *ngIf="
                      form.get('companyInfoForm')?.get('designationId')?.invalid &&
                      form.get('companyInfoForm')?.get('designationId')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('companyInfoForm.designationId') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-lg-12 text-end form-wizard-button">
                <button
                  type="button"
                  (click)="stepChange(1)"
                  class="btn btn-secondary wizard-prev-btn me-3"
                  [disabled]="!form.get('companyInfoForm')?.valid"
                >
                  Previous
                </button>
                <button
                  type="button"
                  (click)="goToNextStep()"
                  [disabled]="!form.get('companyInfoForm')?.valid"
                  class="btn btn-primary wizard-next-btn"
                >
                  Save & Next
                </button>
              </div>
            </div>
          </div>
        </fieldset>

        <!-- Step 3 (Address) -->
        <fieldset *ngIf="currentStep === 3" formGroupName="addressInfoForm">
          <div class="contact-input-set">
            <div class="row">
              <div class="col-lg-12">
                <div class="input-block mb-3">
                  <!-- <label>Street Address *</label> -->
                  <label class="col-form-label"
                    >Street Address <span class="text-danger"> *</span></label
                  >
                  <input formControlName="address" class="form-control" />
                  <div
                    *ngIf="
                      form.get('addressInfoForm')?.get('address')?.invalid &&
                      form.get('addressInfoForm')?.get('address')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('addressInfoForm.address') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label" for="country_id"
                    >Country <span class="text-danger">*</span></label
                  >
                  <select
                    class="form-select"
                    formControlName="country_id"
                    (change)="
                      onCountrySelect(form.get('addressInfoForm')?.get('country_id')?.value)
                    "
                  >
                    <option selected value="">Select Country</option>
                    <option *ngFor="let country of countries$ | async" [value]="country.id">
                      {{ country.name }}
                    </option>
                    <!-- <option>US</option> -->
                  </select>

                  <div
                    *ngIf="
                      form.get('addressInfoForm')?.get('country_id')?.invalid &&
                      form.get('addressInfoForm')?.get('country_id')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('addressInfoForm.country_id') }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label" for="state_id"
                    >State / Province <span class="text-danger"> *</span></label
                  >
                  <!-- <input formControlName="state" class="form-control"> -->
                  <select
                    class="form-select"
                    formControlName="state_id"
                    (change)="onStateSelect(form.get('addressInfoForm')?.get('state_id')?.value)"
                    [disabled]="!selectedCountryId"
                  >
                    <option selected value="">Select State</option>
                    <option *ngFor="let state of states$ | async" [value]="state.id">
                      {{ state.name }}
                    </option>
                    <!-- <option>US</option> -->
                  </select>
                  <div
                    *ngIf="
                      form.get('addressInfoForm')?.get('state_id')?.invalid &&
                      form.get('addressInfoForm')?.get('state_id')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('addressInfoForm.state_id') }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label" for="cityId"
                    >City <span class="text-danger"> *</span></label
                  >
                  <!-- <input formControlName="city" class="form-control"> -->
                  <select
                    class="form-select"
                    formControlName="cityId"
                    [disabled]="!selectedStateId"
                  >
                    <option selected value="">Select City</option>
                    <option *ngFor="let city of cities$ | async" [value]="city.id">
                      {{ city.name }}
                    </option>
                    <!-- <option>US</option> -->
                  </select>
                  <div
                    *ngIf="
                      form.get('addressInfoForm')?.get('city_id')?.invalid &&
                      form.get('addressInfoForm')?.get('city_id')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('addressInfoForm.city_id') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Postal Code <span class="text-danger"> *</span></label
                  >
                  <input formControlName="zipCode" class="form-control" />
                  <div
                    *ngIf="
                      form.get('addressInfoForm')?.get('zipCode')?.invalid &&
                      form.get('addressInfoForm')?.get('zipCode')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('addressInfoForm.zipCode') }}
                    </span>
                  </div>
                </div>
              </div>
              <!-- Other fields for Address here -->
              <div class="col-lg-12 text-end form-wizard-button">
                <button
                  type="button"
                  (click)="stepChange(2)"
                  class="btn btn-secondary wizard-prev-btn me-3"
                  [disabled]="!form.get('addressInfoForm')?.valid"
                >
                  Previous
                </button>
                <button
                  type="button"
                  (click)="goToNextStep()"
                  [disabled]="!form.get('addressInfoForm')?.valid"
                  class="btn btn-primary wizard-next-btn"
                >
                  Save & Next
                </button>
              </div>
            </div>
          </div>
        </fieldset>

        <!-- Step 4 (Social Profiles) -->
        <fieldset *ngIf="currentStep === 4" formGroupName="socialInfoForm">
          <div class="contact-input-set">
            <div class="row">
              <div class="col-lg-12">
                <div class="input-block mb-3">
                  <label>Facebook</label>
                  <input formControlName="referenceIdFacebook" class="form-control" type="url" />
                  <div
                    *ngIf="
                      form.get('socialInfoForm')?.get('referenceIdFacebook')?.invalid &&
                      form.get('socialInfoForm')?.get('referenceIdFacebook')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('socialInfoForm.referenceIdFacebook') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-lg-12">
                <div class="input-block mb-3">
                  <label>Instagram</label>
                  <input formControlName="referenceIdInstagram" class="form-control" type="url" />
                  <div
                    *ngIf="
                      form.get('socialInfoForm')?.get('referenceIdInstagram')?.invalid &&
                      form.get('socialInfoForm')?.get('referenceIdInstagram')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('socialInfoForm.referenceIdInstagram') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-lg-12">
                <div class="input-block mb-3">
                  <label>LinkedIn</label>
                  <input formControlName="referenceIdLinkedIn" class="form-control" type="url" />
                  <div
                    *ngIf="
                      form.get('socialInfoForm')?.get('referenceIdLinkedIn')?.invalid &&
                      form.get('socialInfoForm')?.get('referenceIdLinkedIn')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('socialInfoForm.referenceIdLinkedIn') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-lg-12">
                <div class="input-block mb-3">
                  <label>Twitter</label>
                  <input formControlName="referenceIdTwitter" class="form-control" type="url" />
                  <div
                    *ngIf="
                      form.get('socialInfoForm')?.get('referenceIdTwitter')?.invalid &&
                      form.get('socialInfoForm')?.get('referenceIdTwitter')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('socialInfoForm.referenceIdTwitter') }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-lg-12">
                <div class="input-block mb-3">
                  <label>Whatsapp</label>
                  <input formControlName="referenceIdWhatsapp" class="form-control" type="url" />
                  <div
                    *ngIf="
                      form.get('socialInfoForm')?.get('referenceIdWhatsapp')?.invalid &&
                      form.get('socialInfoForm')?.get('referenceIdWhatsapp')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('socialInfoForm.referenceIdWhatsapp') }}
                    </span>
                  </div>
                </div>
              </div>

              <!-- <div class="col-lg-12">
                <div class="input-block mb-3">
                  <label for="referenceIdSkype">Skype</label>
                  <input formControlName="referenceIdSkype" class="form-control" type="url" />
                  <div
                    *ngIf="
                      form.get('socialInfoForm')?.get('referenceIdSkype')?.invalid &&
                      form.get('socialInfoForm')?.get('referenceIdSkype')?.touched
                    "
                  >
                    <span class="text-danger">
                      {{ getErrorMessage('socialInfoForm.referenceIdSkype') }}
                    </span>
                  </div>
                </div>
              </div> -->

              <div class="col-lg-12 text-end form-wizard-button">
                <!-- <button
                  type="button"
                  (click)="stepChange(3)"
                  class="btn btn-secondary wizard-prev-btn me-3"
                  [disabled]="!form.get('socialInfoForm')?.valid"
                >
                  Previous
                </button> -->
                <button
                  type="button"
                  (click)="stepChange(3)"
                  class="btn btn-secondary wizard-prev-btn me-3"
                >
                  Previous
                </button>
                <!-- <button
                  type="button"
                  [disabled]="!form.get('socialInfoForm')?.valid"
                  class="btn btn-primary wizard-next-btn"
                >
                  Save
                </button> -->
                <!-- <button
                  type="submit"
                  (click)="goToNextStep()"
                  [disabled]="!form.get('socialInfoForm')?.valid"
                  class="btn btn-primary wizard-next-btn"
                > -->
                <button
                  type="submit"
                  (click)="goToNextStep()"
                  class="btn btn-primary wizard-next-btn"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </fieldset>

        <!-- Step 5 (Role & Permission) -->
      </form>
    </div>
  </div>
  <!-- </div>
    </div>
  </div> -->
</ng-template>
<!-- /Edit Employee -->

<!-- Attendance policy offcanvas -->
<div
  class="offcanvas offcanvas-end"
  tabindex="-1"
  id="offcanvasRightAttendancePolicy"
  aria-labelledby="offcanvasRightLabel"
  *ngIf="selectedAttendancePolicy"
>
  <div class="offcanvas-header">
    <h5 id="offcanvasRightLabel">
      {{ selectedAttendancePolicy.title }} -
      {{ selectedAttendancePolicy.policyType }}
    </h5>
    <button
      type="button"
      class="btn-close text-reset"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
    ></button>
  </div>
  <!-- end offcanvas-header-->

  <div class="offcanvas-body">
    <!-- <h5 class="mt-3">List</h5> -->
    <ul class="ps-3 d-none">
      <li class="">Shift Type: {{ selectedAttendancePolicy.shiftType }}</li>
      <li class="">
        Shift Start Time:
        {{ selectedAttendancePolicy.shiftStartTime }} -
        {{ selectedAttendancePolicy.shiftEndTime }}
      </li>
      <li class="">Weekly Offs: {{ selectedAttendancePolicy.weeklyOffs }}</li>
      <li class="">
        Do you want to give break hours between the work hours? :
        {{ selectedAttendancePolicy.isBreakHour ? 'Yes' : 'No' }}
      </li>
      <li class="">
        Is Break Hours:
        {{ selectedAttendancePolicy.isBreakHour ? selectedAttendancePolicy.breakHour : 'N/A' }}
      </li>
      <li class="">
        Is a single clock-in sufficient for the employee to be marked full day present?
        {{ selectedAttendancePolicy.isSingleClockIn ? 'Yes' : 'No' }}
      </li>
    </ul>

    <div class="container">
      <div class="row mb-2">
        <div class="col-md-6 fw-bold">Description</div>
        <div class="col-md-6">
          {{ selectedAttendancePolicy.description }}
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-md-6 fw-bold">Shift Type:</div>
        <div class="col-md-6">
          {{ selectedAttendancePolicy.shiftType }}
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-md-6 fw-bold">Shift Start Time:</div>
        <div class="col-md-6">
          {{ selectedAttendancePolicy.shiftStartTime }} -
          {{ selectedAttendancePolicy.shiftEndTime }}
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-md-6 fw-bold">Weekly Offs:</div>
        <div class="col-md-6">
          {{ selectedAttendancePolicy.weeklyOffs }}
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-md-6 fw-bold">Break Hours Between Work Hours?</div>
        <div class="col-md-6">
          {{ selectedAttendancePolicy.isBreakHour ? 'Yes' : 'No' }}
        </div>
      </div>

      <div class="row mb-2" *ngIf="selectedAttendancePolicy.isBreakHour">
        <div class="col-md-6 fw-bold">Break Duration:</div>
        <div class="col-md-6">
          {{ selectedAttendancePolicy.breakHour }}
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-md-6 fw-bold">Single Clock-In for Full Day Present?</div>
        <div class="col-md-6">
          {{ selectedAttendancePolicy.isSingleClockIn ? 'Yes' : 'No' }}
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-md-6 fw-bold">Minimum Work Hours Required?</div>
        <div class="col-md-6">
          {{ selectedAttendancePolicy.isMinimumWorkHours ? 'Yes' : 'No' }}
        </div>
      </div>

      <div class="row mb-2" *ngIf="selectedAttendancePolicy.isMinimumWorkHours">
        <div class="col-md-6 fw-bold">Minimum Work Hours per Day:</div>
        <div class="col-md-6">
          {{ selectedAttendancePolicy.minimumWorkHours }}
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-md-6 fw-bold">Work Day Extension Minutes:</div>
        <div class="col-md-6">
          {{ selectedAttendancePolicy.workDayExtensionMinutes }}
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-md-6 fw-bold">First Punch In After Shift Start Time:</div>
        <div class="col-md-6">
          {{ selectedAttendancePolicy.firstClockInAfterTime }}
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-md-6 fw-bold">First Punch In Should Be Before:</div>
        <div class="col-md-6">
          {{ selectedAttendancePolicy.firstClockInTime }}
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-md-6 fw-bold">Should Late Status Result in LOP?</div>
        <div class="col-md-6">
          {{ selectedAttendancePolicy.isLossOfPay ? 'Yes' : 'No' }}
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-md-6 fw-bold">
          LOP Days for Every
          {{ selectedAttendancePolicy.everyLateDays }} Late Days:
        </div>
        <div class="col-md-6">
          {{ selectedAttendancePolicy.lopDays }}
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-md-6 fw-bold">Require Selfie for Punch In/Out?</div>
        <div class="col-md-6">
          {{ selectedAttendancePolicy.isSelfie ? 'Yes' : 'No' }}
        </div>
      </div>
    </div>
  </div>
  <!-- end offcanvas-body-->
</div>
<!-- end offcanvas-->

<!-- Leave policy offcanvas -->
<div
  class="offcanvas offcanvas-end"
  tabindex="-1"
  id="offcanvasRightLeavePolicy"
  aria-labelledby="offcanvasRightLeaveLabel"
  *ngIf="selectedLeavePolicy"
>
  <div class="offcanvas-header">
    <h5 id="offcanvasRightLabel">
      {{ selectedLeavePolicy.title }} -
      {{ selectedLeavePolicy.policyType }}
    </h5>
    <button
      type="button"
      class="btn-close text-reset"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
    ></button>
  </div>
  <!-- end offcanvas-header-->

  <div class="offcanvas-body">
    <div class="container">
      <div class="row mb-2">
        <div class="col-md-6 fw-bold">Description</div>
        <div class="col-md-6">
          {{ selectedLeavePolicy.description }}
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-md-6 fw-bold">Leave Type</div>
        <div class="col-md-6">{{ selectedLeavePolicy.leaveType }}</div>
      </div>

      <div class="row mb-2">
        <div class="col-md-6 fw-bold">Effective From</div>
        <div class="col-md-6">{{ selectedLeavePolicy.date | date: 'medium' }}</div>
      </div>

      <div class="row mb-2">
        <div class="col-md-6 fw-bold">Is encashable</div>
        <div class="col-md-6">{{ selectedLeavePolicy.encashable === true ? 'Yes' : 'No' }}</div>
      </div>

      <div class="row mb-2">
        <div class="col-md-6 fw-bold">Accrual Method</div>
        <div class="col-md-6">{{ selectedLeavePolicy.accrualMethod }}</div>
      </div>
      <div class="row mb-2">
        <div class="col-md-6 fw-bold">Accrual Frequency</div>
        <div class="col-md-6">{{ selectedLeavePolicy.accrualFrequency }}</div>
      </div>
      <div class="row mb-2">
        <div class="col-md-6 fw-bold">Accrual happen at</div>
        <div class="col-md-6">
          {{
            selectedLeavePolicy.accrualHappenPeriod === true
              ? 'Begining of the period'
              : 'End of the period'
          }}
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-6 fw-bold">Is Accrual Pro rata basis</div>
        <div class="col-md-6">{{ selectedLeavePolicy.accruedProRataBasis }}</div>
      </div>
      <div class="row mb-2">
        <div class="col-md-6 fw-bold">Balance</div>
        <div class="col-md-6">{{ selectedLeavePolicy.totalPerYear }}</div>
      </div>
      <div class="row mb-2">
        <div class="col-md-6 fw-bold">Max leave balance Cap</div>
        <div class="col-md-6">
          {{ selectedLeavePolicy.maxLeaveBalanceCap === true ? 'yes' : 'no' }}
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-md-6 fw-bold">Is waiting period</div>
        <div class="col-md-6">{{ selectedLeavePolicy.isProbationPeriod }}</div>
      </div>
      <div class="row mb-2">
        <div class="col-md-6 fw-bold">Waiting Period Length</div>
        <div class="col-md-6">{{ selectedLeavePolicy.probationPeriodLength }}</div>
      </div>

      <div class="row mb-2">
        <div class="col-md-6 fw-bold">Reset happen</div>
        <div class="col-md-6">{{ selectedLeavePolicy.resetHappen }}</div>
      </div>
      <div class="row mb-2">
        <div class="col-md-6 fw-bold">Start month of the reset cycle</div>
        <div class="col-md-6">{{ selectedLeavePolicy.resetStart }}</div>
      </div>

      <div class="row mb-2">
        <div class="col-md-6 fw-bold">Leave Advance Notice Period</div>
        <div class="col-md-6">
          {{ selectedLeavePolicy.leaveAdvanceNoticePeriod }}
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-6 fw-bold">Leave Advance notice period days</div>
        <div class="col-md-6">{{ selectedLeavePolicy.leaveAdvanceNoticePeriodDay }}</div>
      </div>
      <div class="row mb-2">
        <div class="col-md-6 fw-bold">Can take half day</div>
        <div class="col-md-6">{{ selectedLeavePolicy.isHalfDay }}</div>
      </div>
      <div class="row mb-2">
        <div class="col-md-6 fw-bold">Can take quarter day</div>
        <div class="col-md-6">{{ selectedLeavePolicy.isQuarterDay }}</div>
      </div>
      <div class="row mb-2">
        <div class="col-md-6 fw-bold">Max Consecutive leaves</div>
        <div class="col-md-6">{{ selectedLeavePolicy.maxConsecutiveLeaves }}</div>
      </div>

      <div class="row mb-2">
        <div class="col-md-6 fw-bold">Is holiday excluded</div>
        <div class="col-md-6">
          {{ selectedLeavePolicy.isHolidayExcluded === true ? 'yes' : 'no' }}
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-md-6 fw-bold">Is weekend excluded</div>
        <div class="col-md-6">
          {{ selectedLeavePolicy.isWeekendExcluded === true ? 'yes' : 'no' }}
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-md-6 fw-bold">Is negative balance allowed</div>
        <div class="col-md-6">
          {{ selectedLeavePolicy.isNagativeBalanceAllowed === true ? 'yes' : 'no' }}
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-md-6 fw-bold">Excluded leave types</div>

        <div class="col-md-6">{{ selectedLeavePolicy.leaveTypeExclude?.join(', ') }}</div>
      </div>
    </div>
  </div>
  <!-- end offcanvas-body-->
</div>
<!-- end offcanvas-->

<!-- assign permission sets -->
<ng-template #assignPermissionSetsModal let-modal>
  <!-- <div class="modal fade" id="edit_bank">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content"> -->
  <div class="modal-header">
    <h4 class="modal-title">Assign Permission Sets</h4>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <form [formGroup]="assignPermissionSetsForm">
    <div class="modal-body pb-0">
      <div class="row">
        <!-- Available Permission Sets -->
        <div class="col-md-5">
          <div class="mb-3">
            <label class="col-form-label" for="availablePermissions"
              >Available Permission Sets <span class="text-danger">*</span></label
            >
            <!-- <select class="form-select" multiple (change)="onAvailableSelect($event)"> -->
            <select
              class="form-select permission-set-list"
              multiple
              (change)="onAvailableSelect($event)"
            >
              <option *ngFor="let permissionSet of permissionSetsList" [value]="permissionSet.id">
                {{ permissionSet.name }}
              </option>
            </select>
          </div>
        </div>

        <!-- Move Buttons -->
        <div class="col-md-2 d-flex flex-column align-items-center justify-content-center">
          <button
            type="button"
            class="btn btn-primary mb-2"
            (click)="moveToAssigned()"
            [disabled]="selectedAvailable.length === 0"
          >
            →
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            (click)="moveToAvailable()"
            [disabled]="selectedAssigned.length === 0"
          >
            ←
          </button>
        </div>

        <!-- Assigned Permission Sets -->
        <div class="col-md-5">
          <div class="mb-3">
            <label class="col-form-label"
              >Assigned Permission Sets <span class="text-danger">*</span></label
            >
            <!-- <select class="form-select" multiple (change)="onAssignedSelect($event)"> -->
            <select
              class="form-select permission-set-list"
              multiple
              (change)="onAssignedSelect($event)"
            >
              <!-- <option
                *ngFor="let assignedpermissionSet of assignedPermissionSets"
                [value]="assignedpermissionSet.id"
              >
                {{ assignedpermissionSet.permissionSet.name }}
              </option> -->
              <option
                *ngFor="let assignedpermissionSet of assignedPermissionSets"
                [value]="assignedpermissionSet.permissionSet?.id || assignedpermissionSet.id"
              >
                {{ assignedpermissionSet.permissionSet?.name || assignedpermissionSet.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-white border me-2"
        data-bs-dismiss="modal"
        (click)="onClose()"
      >
        Cancel
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        (click)="assignPermissionSet()"
        [disabled]="!assignPermissionSetsForm.valid"
      >
        Save
      </button>
    </div>
  </form>
  <!-- </div>
    </div>
  </div> -->
</ng-template>
<!-- assign permission sets -->

<!-- Preview Monthly Salary -->
<ng-template #previewMonthlySalary let-modal>
  <!-- <div class="modal fade" id="edit_personal">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content"> -->
  <div class="modal-header">
    <h4 class="modal-title">
      Monthly take home salary preview for {{ (employee$ | async)?.firstName }}
      <small class="text-muted">{{ (employee$ | async)?.empId }}</small>
    </h4>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <div class="modal-body pb-0">
    <div *ngIf="employee$ | async as employee; else loading" class="container mt-4">
      <div class="row">
        <!-- Main Payslip Section -->
        <div class="col-md-12">
          <p>
            <strong>Total days in payroll period:</strong>
            {{ totalDaysInPayrollPeriod }} &nbsp;&nbsp; <strong>LOP Days:</strong> 0
          </p>
          <div class="earning-deduction-section">
            <!-- Earnings -->
            <div class="earnings">
              <div>
                <h6 class="pb-3">Earnings</h6>
                <p>
                  Basic:
                  {{
                    (employeeSalaryDetails?.salaryData?.basic ?? 0) / 12
                      | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'
                  }}
                </p>
                <p>
                  HRA:
                  {{
                    (employeeSalaryDetails?.salaryData?.hra ?? 0) / 12
                      | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'
                  }}
                </p>
                <ng-container
                  *ngFor="let item of employeeSalaryDetails?.salaryData?.otherComponents"
                >
                  <p *ngIf="item.componentType !== 'customDeductions'">
                    {{ item.name }}:
                    {{
                      (item.employerContribution ?? 0) / 12
                        | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'
                    }}
                  </p>
                  <ng-template #elseBlock>
                    <p>
                      {{ item.name }} - Employer Contribution:
                      {{
                        (item.employerContribution ?? 0) / 12
                          | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'
                      }}
                    </p>
                    <p>
                      {{ item.name }} - Employee Contribution:
                      {{
                        (item.employeeContribution ?? 0) / 12
                          | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'
                      }}
                    </p>
                  </ng-template>
                </ng-container>
                <p>
                  Special Allowances:
                  {{
                    (employeeSalaryDetails?.salaryData?.specialAllowance ?? 0) / 12
                      | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'
                  }}
                </p>
              </div>
              <div class="totals-row">
                <span
                  >Total Earnings:
                  {{ monthlyTotalEarnings | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN' }}</span
                >
              </div>
            </div>

            <!-- Deductions -->
            <div class="deductions">
              <div>
                <h6 class="pb-3">Deductions</h6>
                <p>
                  Pf:
                  {{
                    (employeeSalaryDetails?.salaryData?.pf ?? 0) / 12
                      | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'
                  }}
                </p>
                <ng-container
                  *ngFor="let item of employeeSalaryDetails?.salaryData?.otherComponents"
                >
                  <ng-container *ngIf="item.componentType === 'customDeductions'">
                    <p>
                      {{ item.name }} - Employer Contribution: ₹{{
                        (item.employerContribution ?? 0) / 12
                          | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'
                      }}
                    </p>
                    <p>
                      {{ item.name }} - Employee Contribution: ₹{{
                        (item.employeeContribution ?? 0) / 12
                          | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'
                      }}
                    </p>
                  </ng-container>
                </ng-container>
              </div>
              <div class="totals-row text-end">
                <span
                  >Total Deductions:
                  {{
                    monthlyTotalDeductions | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'
                  }}</span
                >
              </div>
            </div>
          </div>

          <h5 class="mt-5">
            Net Salary<span class="text-danger">*</span>
            {{
              monthlyTotalEarnings - monthlyTotalDeductions
                | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'
            }}
            <small class="text-muted">/month</small>
          </h5>
          <p class="text-muted small">
            <span class="text-danger">*</span> This is just for information purpose only, actual
            values may differ based on payroll input, investment declarations by employee or any
            change in previous income declaration
          </p>
        </div>

        <!-- Settings and Assumptions Section -->
        <!--<div class="col-md-5">
          <div class="settings-scroll border p-3">
            <h6>Settings and Assumptions</h6>
            <p class="text-muted small">
              Feel free to play around without any worry because any settings changes won’t be saved
            </p>

            <div>
              <h6 class="pb-3">Payroll Inputs <a href="#">✏️ Edit</a></h6>
              <p><strong>Period:</strong> 01 Mar - 31 Mar, 2025</p>
              <p><strong>LOP Days:</strong> 0 day(s)</p>
              <p><strong>Bonus:</strong> ₹0.00</p>
              <p><strong>Leave Travel Allowance:</strong> ₹0.00</p>
              <p><strong>Commission:</strong> ₹0.00</p>
            </div>

            <div>
              <h6 class="py-3">Investment Declarations</h6>
              <p>Section 10: ₹0.00</p>
              <p>Section 80C: ₹0.00</p>
              <p>Section 80D: ₹0.00</p>
              <p>Section 80E: ₹0.00</p>
              <a href="#">View More ...</a>
            </div>
          </div>
        </div>-->
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <!--<button
        type="button"
        class="btn btn-white border me-2"
        data-bs-dismiss="modal"
        (click)="onClose()"
      >
        Cancel
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        (click)="onFamilySubmit()"
        [disabled]="!personalform.valid"
      >
        Save
      </button>-->
  </div>
  <!-- </div>
      </div>
    </div> -->
</ng-template>
<!-- /Preview Monthly Salary -->

<!-- View All Salaries -->
<!-- <ng-template #viewAllSalaries let-modal>
  <div class="modal-header">
    <h4 class="modal-title">
      Salaries of {{ (employee$ | async)?.firstName }}
      <small class="text-muted">{{ (employee$ | async)?.empId }}</small>
    </h4>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <div class="modal-body pb-0">
    <div *ngIf="employee$ | async as employee; else loading" class="container mt-4">
      <div class="row">
        <div class="col-md-12">
          <table class="table">
            <thead class="thead-light">
              <tr>
                <th>CTC</th>
                <th>Effective From</th>
                <th>Payout From</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let salary of allSalaries$ | async">
                <td>
                  {{
                    salary.ctc.ctc
                      | currency
                        : employeeSalaryDetails?.ctc?.currency
                        : 'symbol'
                        : '1.0-0'
                        : 'en-IN'
                  }}
                </td>
                <td>{{ salary.effectiveFrom | date: 'MMM dd, yyyy' }}</td>
                <td>{{ salary.payoutFrom | date: 'MMM yyyy' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer"></div>
</ng-template> -->

<ng-template #viewAllSalaries let-modal>
  <div class="modal-header">
    <h4 class="modal-title">
      Salaries of {{ (employee$ | async)?.firstName }}
      <small class="text-muted">
        {{ (employee$ | async)?.empId }}
      </small>
    </h4>
    <button type="button" class="btn-close" (click)="onClose()"></button>
  </div>

  <div class="modal-body">
    <ng-container *ngIf="allSalaries$ | async as salaries">
      <h5 class="mb-3">Salary History</h5>

      <div class="table-responsive">
        <table class="table table-hover align-middle">
          <thead>
            <tr>
              <th>CTC</th>
              <th>Basic</th>
              <th>HRA</th>
              <th>Special Allowance</th>
              <th>Effective From</th>
              <th>Payout From</th>
              <th>Last Updated</th>
            </tr>
          </thead>

          <tbody>
            <ng-container *ngFor="let salary of salaries">
              <tr
                (click)="toggleSalaryDetails(salary)"
                style="cursor: pointer"
                [class.table-active]="selectedSalaryId === salary.id"
              >
                <td>
                  {{ salary.ctc?.ctc | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN' }}
                </td>
                <td>
                  {{ salary.salaryData?.basic | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN' }}
                </td>
                <td>
                  {{ salary.salaryData?.hra | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN' }}
                </td>
                <td>
                  {{
                    salary.salaryData?.specialAllowance
                      | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'
                  }}
                </td>
                <td>{{ salary.effectiveFrom | date: 'dd MMM yyyy' }}</td>
                <td>{{ getPayoutDate(salary.payoutFrom) | date: 'MMM yyyy' }}</td>
                <td>{{ salary.updatedAt | date: 'dd MMM yyyy, hh:mm a' }}</td>
              </tr>

              <tr *ngIf="selectedSalaryId === salary.id">
                <td colspan="7" class="p-0">
                  <div class="p-4 bg-light">
                    <!-- <h5>Salary Details</h5>

                    <h6 class="mt-3">Salary Components</h6> -->
                    <table class="table table-bordered bg-white">
                      <thead>
                        <tr>
                          <th>Component</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Basic</td>
                          <td>
                            {{
                              salary.salaryData?.basic
                                | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>HRA</td>
                          <td>
                            {{
                              salary.salaryData?.hra
                                | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>Special Allowance</td>
                          <td>
                            {{
                              salary.salaryData?.specialAllowance
                                | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>PF</td>
                          <td>
                            {{
                              salary.salaryData?.pf | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'
                            }}
                          </td>
                        </tr>

                        <tr *ngFor="let component of salary.salaryData?.otherComponents">
                          <td>
                            {{ component.name }}
                            <small class="d-block text-muted">
                              {{ component.description }}
                            </small>
                            <small class="d-block text-muted">
                              {{ component.componentType }}
                            </small>
                          </td>
                          <td>
                            Employee:
                            {{
                              component.employeeContribution
                                | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'
                            }}
                            <br />
                            Employer:
                            {{
                              component.employerContribution
                                | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'
                            }}
                          </td>
                        </tr>

                        <tr *ngIf="!salary.salaryData?.otherComponents?.length">
                          <td colspan="2">No additional components</td>
                        </tr>
                      </tbody>
                    </table>

                    <!-- <h6 class="mt-4">Statutory Compliances</h6>
                    <div class="row">
                      <div
                        class="col-md-4 mb-2"
                        *ngFor="let item of salary.statutoryCompliances | keyvalue"
                      >
                        <strong>{{ item.key | uppercase }}:</strong>
                        <span [class.text-success]="item.value" [class.text-danger]="!item.value">
                          {{ item.value ? 'Enabled' : 'Disabled' }}
                        </span>
                      </div>
                    </div> -->

                    <h6 class="mt-4">Audit Information</h6>
                    <div class="row">
                      <div class="col-md-6 mb-3">
                        <strong>Created At:</strong><br />
                        {{ salary.createdAt | date: 'dd MMM yyyy, hh:mm:ss a' }}
                      </div>
                      <div class="col-md-6 mb-3">
                        <strong>Last Updated At:</strong><br />
                        {{ salary.updatedAt | date: 'dd MMM yyyy, hh:mm:ss a' }}
                      </div>
                      <div class="col-md-6 mb-3">
                        <strong>Effective From:</strong><br />
                        {{ salary.effectiveFrom | date: 'dd MMM yyyy' }}
                      </div>
                      <div class="col-md-6 mb-3">
                        <strong>Payout From:</strong><br />
                        {{ getPayoutDate(salary.payoutFrom) | date: 'MMM yyyy' }}
                      </div>
                      <!-- <div class="col-md-6 mb-3">
                        <strong>Employee ID:</strong><br />
                        {{ salary.employeeId }}
                      </div>
                      <div class="col-md-6 mb-3">
                        <strong>Record ID:</strong><br />
                        {{ salary.id }}
                      </div>
                      <div class="col-md-6 mb-3">
                        <strong>Organization ID:</strong><br />
                        {{ salary.belongsTo }}
                      </div>
                      <div class="col-md-6 mb-3">
                        <strong>Deleted At:</strong><br />
                        {{
                          salary.deletedAt
                            ? (salary.deletedAt | date: 'dd MMM yyyy, hh:mm a')
                            : 'Not deleted'
                        }}
                      </div>  <div class="col-md-6 mb-3">
                        <strong>Base Salary:</strong><br />
                        {{ salary.baseSalary ?? 'N/A' }}
                      </div> 
                       <div class="col-md-6 mb-3">
                        <strong>Salary Structure:</strong><br />
                        {{ salary.salaryData ?? 'N/A' }}
                      </div> -->
                    </div>

                    <ng-container *ngFor="let component of salary.salaryData?.otherComponents">
                      <h6 class="mt-3">{{ component.name }} Configuration</h6>
                      <div class="row">
                        <div
                          class="col-md-4 mb-2"
                          *ngFor="let item of getComponentInfo(component.info)"
                        >
                          <strong>{{ item.key }}:</strong> {{ item.value }}
                        </div>
                      </div>
                    </ng-container>

                    <button
                      class="btn btn-sm btn-secondary mt-3"
                      type="button"
                      (click)="toggleSalaryDetails(salary)"
                    >
                      Close Details
                    </button>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </ng-container>
  </div>

  <div class="modal-footer">
    <button class="btn btn-light" type="button" (click)="onClose()">Close</button>
  </div>
</ng-template>
<!-- /View All Salaries -->

<!-- Roles offcanvas -->
<div
  class="offcanvas offcanvas-end"
  tabindex="-1"
  id="offcanvasRightRoles"
  aria-labelledby="offcanvasRightRolesLabel"
>
  <div class="offcanvas-header">
    <h5 id="offcanvasRightRolesLabel">
      {{ viewAssignedRole.roleType }} - {{ viewAssignedRole.name }}
    </h5>
    <button
      type="button"
      class="btn-close text-reset"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
    ></button>
  </div>
  <!-- end offcanvas-header-->

  <div class="offcanvas-body">
    <div class="table-responsive permission-scroll">
      <table class="table">
        <thead class="thead-light">
          <tr>
            <th>Module Permissions</th>
            <th>Read</th>
            <th>Create</th>
            <th>Edit</th>
            <th>Delete</th>
            <!-- <th>Import</th>
                    <th>Export</th> -->
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let module of permissionModules">
            <td>
              <h6 class="fs-14 fw-normal text-gray-9">{{ module.name }}</h6>
            </td>
            <td>
              <div class="form-check form-check-md">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="read-{{ module.name }}"
                  name="read-{{ module.name }}"
                  [checked]="permissionsState[module.key]?.view"
                  disabled
                />
              </div>
            </td>
            <td>
              <div class="form-check form-check-md">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="create-{{ module.name }}"
                  name="create-{{ module.name }}"
                  [checked]="permissionsState[module.key]?.add"
                  disabled
                />
              </div>
            </td>
            <td>
              <div class="form-check form-check-md">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="update-{{ module.name }}"
                  name="update-{{ module.name }}"
                  [checked]="permissionsState[module.key]?.edit"
                  disabled
                />
              </div>
            </td>
            <td>
              <div class="form-check form-check-md">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="delete-{{ module.name }}"
                  name="delete-{{ module.name }}"
                  [checked]="permissionsState[module.key]?.delete"
                  disabled
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <!-- end offcanvas-body-->
</div>
<!-- end Roles offcanvas-->

<app-block-unblock
  *ngIf="showModal"
  [isBlocking]="isBlocking"
  [recordId]="blockEmployeeId"
  [title]="title"
  [desc]="desc"
></app-block-unblock>

<app-delete *ngIf="showDeleteModal" [recordId]="deleteRecordId"></app-delete>

<ng-template #loading>
  <!-- <p>Loading business details...</p> -->
  <app-loader></app-loader>
</ng-template>

<!-- Modal -->
<!-- <div
  class="modal fade"
  id="resetPasswordModal"
  tabindex="-1"
  aria-labelledby="resetPasswordModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="resetPasswordModalLabel">Confirm Reset</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        Are you sure you want to send a password reset email to this user?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
        <button
          type="button"
          class="btn btn-primary ms-2"
          (click)="sendPasswordResetEmail()"
          data-bs-dismiss="modal"
        >
          Yes, Send Email
        </button>
      </div>
    </div>
  </div>
</div> -->
<!-- Change Password Modal -->
<div
  class="modal fade"
  id="changePasswordModal"
  tabindex="-1"
  aria-labelledby="changePasswordModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <form [formGroup]="changePasswordForm" (ngSubmit)="onChangePassword()">
        <div class="modal-header">
          <h5 class="modal-title" id="changePasswordModalLabel">Change Password</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label for="oldPassword" class="form-label">Old Password</label>
            <input
              type="password"
              id="oldPassword"
              class="form-control"
              formControlName="oldPassword"
            />
            <div
              *ngIf="
                changePasswordForm.get('oldPassword')?.invalid &&
                changePasswordForm.get('oldPassword')?.touched
              "
              class="text-danger"
            >
              Old password is required.
            </div>
          </div>

          <div class="mb-3">
            <label for="newPassword" class="form-label">New Password</label>
            <input
              type="password"
              id="newPassword"
              class="form-control"
              formControlName="newPassword"
              appTrimInput
            />
            <div
              *ngIf="
                changePasswordForm.get('newPassword')?.invalid &&
                changePasswordForm.get('newPassword')?.touched
              "
              class="text-danger"
            >
              New password is required (min 6 chars).
            </div>
          </div>

          <div class="mb-3">
            <label for="confirmPassword" class="form-label">Confirm New Password</label>
            <input
              type="password"
              id="confirmPassword"
              class="form-control"
              formControlName="confirmPassword"
              appTrimInput
            />
            <div
              *ngIf="
                changePasswordForm.hasError('passwordMismatch') &&
                changePasswordForm.get('confirmPassword')?.touched
              "
              class="text-danger"
            >
              Passwords do not match.
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary me-2"
            data-bs-dismiss="modal"
            (click)="onClose()"
          >
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="changePasswordForm.invalid"
            data-bs-dismiss="modal"
          >
            Change Password
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Reset Password Modal -->
<div
  class="modal fade"
  id="resetPasswordModal"
  tabindex="-1"
  aria-labelledby="resetPasswordModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="resetPasswordModalLabel">Reset Password</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p>Are you sure to reset password?</p>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary me-2"
          data-bs-dismiss="modal"
          (click)="onClose()"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="btn btn-primary"
          (click)="sendPasswordResetEmail()"
          data-bs-dismiss="modal"
        >
          Yes
        </button>
      </div>
    </div>
  </div>
</div>

<!-- assign manager -->
<ng-template #assignManagerModal let-modal>
  <!-- <div class="modal fade" id="assign_businessowner">
    <div class="mod al-dialog modal-dialog-centered modal-lg">
      <div class="modal-content"> -->
  <div class="modal-header">
    <h4 class="modal-title">Change Manager</h4>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <form [formGroup]="assignManagerform">
    <div class="modal-body pb-0">
      <div class="row">
        <div class="col-md-12">
          <label class="form-label">Reporting Manager</label>

          <ng-select
            class="mb-3"
            [items]="filteredUsers$ | async"
            bindValue="id"
            formControlName="managerId"
            [searchable]="true"
            [clearable]="true"
            [searchFn]="customSearchFn"
            placeholder="Select Manager"
            [ngClass]="{
              'is-invalid':
                assignManagerform.get('managerId')?.invalid &&
                (assignManagerform.get('managerId')?.touched ||
                  assignManagerform.get('managerId')?.dirty)
            }"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item.firstName }} {{ item.lastName }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              {{ item.firstName }} {{ item.lastName }}
            </ng-template>
          </ng-select>

          <div
            *ngIf="
              assignManagerform.get('managerId')?.invalid &&
              (assignManagerform.get('managerId')?.touched ||
                assignManagerform.get('managerId')?.dirty)
            "
          >
            <span class="text-danger">
              {{ getErrorMessage('assignManagerform.managerId') }}
            </span>
          </div>
          <!-- </div> -->
        </div>

        <div class="col-md-12">
          <label class="form-label">Request Manager</label>
          <ng-select
            class="mb-3"
            [items]="filteredUsers$ | async"
            bindValue="id"
            formControlName="reqManagerId"
            [searchable]="true"
            [clearable]="true"
            [searchFn]="customSearchFn"
            placeholder="Select Request Manager"
            [ngClass]="{
              'is-invalid':
                assignManagerform.get('reqManagerId')?.invalid &&
                (assignManagerform.get('reqManagerId')?.touched ||
                  assignManagerform.get('reqManagerId')?.dirty)
            }"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item.firstName }} {{ item.lastName }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              {{ item.firstName }} {{ item.lastName }}
            </ng-template>
          </ng-select>

          <div
            *ngIf="
              assignManagerform.get('reqManagerId')?.invalid &&
              (assignManagerform.get('reqManagerId')?.touched ||
                assignManagerform.get('reqManagerId')?.dirty)
            "
          >
            <span class="text-danger">
              {{ getErrorMessage('assignManagerform.reqManagerId') }}
            </span>
          </div>
          <!-- </div> -->
        </div>

        <div class="col-md-12">
          <label class="form-label">HR Manager</label>
          <ng-select
            class="mb-3"
            [items]="filteredUsers$ | async"
            bindValue="id"
            formControlName="hrManagerId"
            [searchable]="true"
            [clearable]="true"
            [searchFn]="customSearchFn"
            placeholder="Select HR Manager"
            [ngClass]="{
              'is-invalid':
                assignManagerform.get('hrManagerId')?.invalid &&
                (assignManagerform.get('hrManagerId')?.touched ||
                  assignManagerform.get('hrManagerId')?.dirty)
            }"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item.firstName }} {{ item.lastName }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              {{ item.firstName }} {{ item.lastName }}
            </ng-template>
          </ng-select>

          <div
            *ngIf="
              assignManagerform.get('hrManagerId')?.invalid &&
              (assignManagerform.get('hrManagerId')?.touched ||
                assignManagerform.get('hrManagerId')?.dirty)
            "
          >
            <span class="text-danger">
              {{ getErrorMessage('assignManagerform.hrManagerId') }}
            </span>
          </div>
          <!-- </div> -->
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal" (click)="onClose()">
        Cancel
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="!assignManagerform.valid"
        (click)="assignManager()"
      >
        <ng-container *ngIf="isLoading$ | async; else loading">
          <span
            class="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
          ></span>
          Change Manager...
        </ng-container>
        <ng-template #loading> Change Manager </ng-template>
      </button>
    </div>
  </form>
  <!-- </div>
    </div>
  </div> -->
</ng-template>
<!-- /assign manager -->

<!-- assign role -->
<ng-template #assignRoleModal let-modal>
  <!-- <div class="modal fade" id="assign_businessowner">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content"> -->
  <div class="modal-header">
    <h4 class="modal-title">Change Role</h4>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <form [formGroup]="assignRoleform">
    <div class="modal-body pb-0">
      <div class="row">
        <div class="col-md-12">
          <label class="form-label">Role</label>

          <ng-select
            class="mb-3"
            [items]="roles$ | async"
            bindValue="id"
            formControlName="roleId"
            [searchable]="true"
            [clearable]="true"
            [searchFn]="customRoleSearchFn"
            placeholder="Select Role"
            [ngClass]="{
              'is-invalid':
                assignRoleform.get('roleId')?.invalid &&
                (assignRoleform.get('roleId')?.touched || assignRoleform.get('roleId')?.dirty)
            }"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item.name }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              {{ item.name }}
            </ng-template>
          </ng-select>

          <div
            *ngIf="
              assignRoleform.get('roleId')?.invalid &&
              (assignRoleform.get('roleId')?.touched || assignRoleform.get('roleId')?.dirty)
            "
          >
            <span class="text-danger">
              {{ getErrorMessage('assignRoleform.roleId') }}
            </span>
          </div>
          <!-- </div> -->
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal" (click)="onClose()">
        Cancel
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="!assignRoleform.valid"
        (click)="assignRole()"
      >
        <ng-container *ngIf="isLoading$ | async; else loading">
          <span
            class="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
          ></span>
          Change Role...
        </ng-container>
        <ng-template #loading> Change Role </ng-template>
      </button>
    </div>
  </form>
  <!-- </div>
    </div>
  </div> -->
</ng-template>
<!-- /assign role -->

<!-- Off Board Modal -->
<ng-template #offBoardModal let-modal>
  <form [formGroup]="offBoardForm" (ngSubmit)="onOffBoard()">
    <div class="modal-header">
      <h5 class="modal-title" id="offBoardModalLabel">Off Boarding</h5>
      <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
      <button
        type="button"
        class="btn-close custom-btn-close"
        data-bs-dismiss="modal"
        aria-label="Close"
        (click)="onClose()"
      >
        <i class="ti ti-x"></i>
      </button>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-6 mb-3">
          <label for="date" class="form-label"
            >Off Boarding Date <span class="text-danger">*</span>
          </label>
          <input type="date" id="date" class="form-control" formControlName="date" />
          <div
            *ngIf="offBoardForm.get('date')?.invalid && offBoardForm.get('date')?.touched"
            class="text-danger"
          >
            Off Boarding Date is required.
          </div>
        </div>

        <div class="col-md-6 mb-3">
          <label for="effectiveLastDay" class="form-label"
            >Last Working Date<span class="text-danger">*</span></label
          >
          <input
            type="date"
            id="effectiveLastDay"
            class="form-control"
            formControlName="effectiveLastDay"
            appTrimInput
          />
          <div
            *ngIf="
              offBoardForm.get('effectiveLastDay')?.invalid &&
              offBoardForm.get('effectiveLastDay')?.touched
            "
            class="text-danger"
          >
            Last working date is required.
          </div>
        </div>
      </div>
      <div class="mb-3">
        <label class="form-label" for="offboardingType"
          >Off Boarding Type <span class="text-danger"> *</span></label
        >
        <select class="form-select" formControlName="offboardingType">
          <option selected value="">Select Offboarding Type</option>
          <option [value]="offBoardingEnum.RETIREMENT">{{ offBoardingEnum.RETIREMENT }}</option>
          <option [value]="offBoardingEnum.RESIGNATION">{{ offBoardingEnum.RESIGNATION }}</option>
          <option [value]="offBoardingEnum.TERMINATION">
            {{ offBoardingEnum.TERMINATION }}
          </option>
          <option [value]="offBoardingEnum.LAYOFF">
            {{ offBoardingEnum.LAYOFF }}
          </option>
          <option [value]="offBoardingEnum.CONTRACT">{{ offBoardingEnum.CONTRACT }}</option>
          <option [value]="offBoardingEnum.SEASONAL">{{ offBoardingEnum.SEASONAL }}</option>
        </select>
        <div
          *ngIf="
            offBoardForm.get('offboardingType')?.invalid &&
            offBoardForm.get('offboardingType')?.touched
          "
        >
          <span class="text-danger">
            {{ getErrorMessage('offboardingType') }}
          </span>
        </div>
      </div>

      <div class="col-md-12">
        <div class="mb-3">
          <label for="isSalaryHold" class="form-label col-lg-12">Is salary hold?</label>

          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              id="isSalaryHoldYes"
              [value]="true"
              formControlName="isSalaryHold"
            />
            <label class="form-check-label" for="isSalaryHoldYes">Yes</label>
          </div>

          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              id="isSalaryHoldNo"
              [value]="false"
              formControlName="isSalaryHold"
            />
            <label class="form-check-label" for="isSalaryHoldNo">No</label>
          </div>
        </div>

        <!-- Show date fields only when salary hold = true -->
        <div class="col-md-10 ms-5" *ngIf="offBoardForm.get('isSalaryHold')?.value === true">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label for="salaryHoldFrom" class="form-label">
                From <span class="text-danger">*</span>
              </label>
              <input
                type="date"
                id="salaryHoldFrom"
                class="form-control"
                formControlName="salaryHoldFrom"
                [max]="offBoardForm.get('effectiveLastDay')?.value"
                appTrimInput
              />
              <div
                *ngIf="
                  offBoardForm.get('salaryHoldFrom')?.invalid &&
                  offBoardForm.get('salaryHoldFrom')?.touched
                "
                class="text-danger"
              >
                Salary hold from is required.
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label for="salaryHoldTo" class="form-label">
                To <span class="text-danger">*</span>
              </label>
              <input
                type="date"
                id="salaryHoldTo"
                class="form-control"
                formControlName="salaryHoldTo"
                [min]="offBoardForm.get('salaryHoldFrom')?.value"
                [max]="offBoardForm.get('effectiveLastDay')?.value"
                appTrimInput
              />
              <div
                *ngIf="
                  offBoardForm.get('salaryHoldTo')?.invalid &&
                  offBoardForm.get('salaryHoldTo')?.touched
                "
                class="text-danger"
              >
                Salary hold to is required.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12" *ngIf="offBoardForm.get('isSalaryHold')?.value === true">
        <div class="mb-3">
          <label for="isFullNFinalRequired" class="form-label col-lg-12"
            >Is full & final needed?</label
          >

          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              id="isFullNFinalRequiredYes"
              [value]="true"
              formControlName="isFullNFinalRequired"
            />
            <label class="form-check-label" for="isFullNFinalRequiredYes">Yes</label>
          </div>

          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              id="isFullNFinalRequiredNo"
              [value]="false"
              formControlName="isFullNFinalRequired"
              checked
            />
            <label class="form-check-label" for="isFullNFinalRequiredNo">No</label>
          </div>
        </div>

        <div
          class="col-md-10 ms-5"
          *ngIf="offBoardForm.get('isFullNFinalRequired')?.value === true"
        >
          <div class="row">
            <div class="col-md-6 mb-3">
              <label for="fullNFinalDate" class="form-label">
                Date <span class="text-danger">*</span>
              </label>
              <input
                type="date"
                id="fullNFinalDate"
                class="form-control"
                formControlName="fullNFinalDate"
                appTrimInput
              />
              <div
                *ngIf="
                  offBoardForm.get('fullNFinalDate')?.invalid &&
                  offBoardForm.get('fullNFinalDate')?.touched
                "
                class="text-danger"
              >
                Full & Final date is required.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-3">
        <label class="form-label">Reason <span class="text-danger">*</span></label>
        <textarea class="form-control" rows="3" formControlName="reason" appTrimInput></textarea>
        <div *ngIf="offBoardForm.get('reason')?.invalid && offBoardForm.get('reason')?.touched">
          <span class="text-danger">
            {{ getErrorMessage('reason') }}
          </span>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary me-2"
        data-bs-dismiss="modal"
        (click)="onClose()"
      >
        Cancel
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="offBoardForm.invalid || isSubmitting"
      >
        Off Board
      </button>
    </div>
  </form>
</ng-template>

<!-- view Permission Set -->
<ng-template #viewBusinessModals let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{ modalTitle }}</h4>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <div class="modal-body pb-0">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table">
                <thead class="thead-light">
                  <tr>
                    <th>Module Permissions</th>
                    <th>
                      <div class="form-check form-check-md">
                        <input class="form-check-input me-2" type="checkbox" disabled />
                        Read
                      </div>
                    </th>
                    <th>
                      <div class="form-check form-check-md">
                        <input class="form-check-input me-2" type="checkbox" disabled />
                        Create
                      </div>
                    </th>
                    <th>
                      <div class="form-check form-check-md">
                        <input class="form-check-input me-2" type="checkbox" disabled />
                        Edit
                      </div>
                    </th>
                    <th>
                      <div class="form-check form-check-md me-2">
                        <input class="form-check-input me-2" type="checkbox" disabled />
                        Delete
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let module of permissionModules">
                    <td>
                      <h6 class="fs-14 fw-normal text-gray-9">{{ module.name }}</h6>
                    </td>
                    <td>
                      <div class="form-check form-check-md">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          [checked]="permissionsState[module.key]?.view"
                          disabled
                        />
                      </div>
                    </td>
                    <td>
                      <div class="form-check form-check-md">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          [checked]="permissionsState[module.key]?.add"
                          disabled
                        />
                      </div>
                    </td>
                    <td>
                      <div class="form-check form-check-md">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          [checked]="permissionsState[module.key]?.edit"
                          disabled
                        />
                      </div>
                    </td>
                    <td>
                      <div class="form-check form-check-md">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          [checked]="permissionsState[module.key]?.delete"
                          disabled
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<!-- /view Permission Set -->
